var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewAllPlayers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 138,
    viewBox: "0 0 138 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10072_7190)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 138,
    height: 138,
    rx: 69,
    fill: "#F8C9F4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M18.7279 43.2238C6.47582 53.2475 22.8548 66.1126 14.3698 71.7287C5.88483 77.3448 -29.2556 88.2995 6.13136 110.03C41.5183 131.761 42.4909 146.16 67.7517 132.401C93.0124 118.641 91.1989 116.169 111.988 125.471C132.778 134.773 154.504 120.301 147.117 103.125C139.73 85.9494 135.025 86.1634 143.461 75.1953C151.897 64.2272 138.705 33.8737 109.667 57.3308C80.6286 80.788 62.453 63.2762 59.2633 54.5027C56.0753 45.7293 38.0889 27.3851 18.7279 43.2238Z",
    fill: "url(#paint0_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M100.169 47.4726C108.55 57.1102 137.63 46.4028 137.324 64.1721C136.966 84.9783 108.384 91.0992 117.639 105.723C126.894 120.346 116.673 136.737 79.4845 136.427C42.2959 136.118 -17.5329 117.766 -3.11943 97.8335C11.294 77.8997 1.69125 76.8785 0.987127 68.0682C0.28469 59.258 7.57586 39.936 36.3792 56.0505C65.1825 72.165 78.9492 23.0677 100.169 47.4726Z",
    fill: "url(#paint1_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.887 132.105C152.148 130.594 149.031 130.504 146.453 129.76C144.909 129.314 143.56 128.632 142.821 127.266C141.433 124.7 140.698 120.52 137.572 119.47C134.268 118.359 131.207 121.06 127.954 120.808C123.294 120.448 124.29 115.623 121.276 113.336C118.532 111.255 114.134 111.767 111.903 114.252C110.346 115.987 108.886 121.401 105.86 121.078C104.453 120.928 103.339 118.825 101.929 118.369C98.5568 117.276 96.306 120.097 94.69 122.528C93.503 124.311 93.1214 125.252 90.9009 125.854C86.7555 126.979 80.1685 125.304 81.0111 131.966C81.1647 133.18 81.9212 134.184 82.9614 134.724C87.6809 134.604 92.4257 134.266 97.1148 134.923C106.731 133.31 117.013 135.038 126.654 134.998C135.391 134.962 144.127 134.876 152.864 134.818C153.512 134.813 154.092 134.413 154.32 133.812C154.546 133.208 154.374 132.53 153.887 132.105Z",
    fill: "url(#paint2_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1486 125.787C94.5982 125.422 93.9903 125.17 93.3858 125.081C89.5325 124.52 81.8834 129.073 78.5755 125.321C76.6995 123.193 79.0095 120.343 78.4083 117.779C76.399 109.189 66.9532 115.658 61.8791 116.012C58.3551 116.258 55.8088 114.085 53.4431 111.773C48.9634 107.398 43.9011 98.6926 36.3499 101.634C32.5304 103.124 32.7161 107.819 31.1559 110.926C29.3964 114.428 26.1916 116.748 22.21 117.104C16.6361 117.602 8.72182 112.86 3.74903 116.748C1.89162 118.2 -0.941765 123.061 -0.268032 125.426C-3.1926 125.183 -6.95301 124.44 -9.08058 127.059C-9.82186 127.971 -11.0562 129.935 -9.84887 130.947C-8.34775 132.204 -4.99766 130.945 -3.25001 130.938C9.10343 130.9 21.4434 131.149 33.7951 131.306C45.0713 131.45 56.3744 131.358 67.6354 132C74.0637 132.366 80.4785 132.82 86.9153 132.992C89.8348 133.071 95.5539 133.653 97.0702 130.367C97.8115 128.76 96.7139 126.823 95.1486 125.787Z",
    fill: "url(#paint3_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6133 113.563V136.609C48.6133 137.571 49.5133 138.301 50.4842 138.301H95.4267C96.3976 138.301 97.0747 137.572 97.0747 136.609V113.563H48.6133Z",
    fill: "url(#paint4_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9429 112.495C99.9429 113.085 99.46 113.564 98.8639 113.564H47.1571C46.5611 113.564 46.0781 113.085 46.0781 112.495V112.459C46.0781 111.869 46.5611 111.391 47.1571 111.391H98.8639C99.46 111.391 99.9429 111.869 99.9429 112.459V112.495Z",
    fill: "url(#paint5_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.148438 121.085V137.14C0.148438 137.808 1.04844 138.301 2.01935 138.301H46.9618C47.9328 138.301 48.6099 137.81 48.6099 137.14V121.085H0.148438Z",
    fill: "url(#paint6_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.314 120.184C51.314 120.774 50.8311 121.252 50.235 121.252H-1.4718C-2.06786 121.252 -2.55078 120.774 -2.55078 120.184V120.147C-2.55078 119.557 -2.06786 119.079 -1.4718 119.079H50.235C50.8311 119.079 51.314 119.557 51.314 120.147V120.184Z",
    fill: "url(#paint7_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0703 125.932V137.48C97.0703 137.962 97.9703 138.301 98.9412 138.301H143.884C144.855 138.301 145.532 137.962 145.532 137.48V125.932H97.0703Z",
    fill: "url(#paint8_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.236 125.199C148.236 125.789 147.753 126.267 147.157 126.267H95.4501C94.854 126.267 94.3711 125.789 94.3711 125.199V125.162C94.3711 124.572 94.854 124.094 95.4501 124.094H147.157C147.753 124.094 148.236 124.572 148.236 125.162V125.199Z",
    fill: "url(#paint9_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4102 111.374C64.4102 111.344 64.4118 111.314 64.4203 111.282C64.883 109.467 66.7741 108.536 66.7741 108.536L67.6843 108.606C68.2077 110.206 68.5454 110.986 68.461 111.424C68.4593 111.436 68.4542 111.448 68.4509 111.459C67.7011 111.528 66.1561 111.571 64.4102 111.374Z",
    fill: "url(#paint10_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4509 111.461C68.4103 111.606 68.3023 111.72 68.1621 111.75C67.095 111.972 65.398 111.794 64.6854 111.702C64.5284 111.682 64.4135 111.538 64.4102 111.376C66.1561 111.571 67.7011 111.528 68.4509 111.461Z",
    fill: "url(#paint11_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0234 107.135L66.4219 109.034C66.4506 109.173 66.5587 109.278 66.6904 109.29C66.8508 109.305 67.0788 109.313 67.3067 109.279C67.5127 109.249 67.6546 109.042 67.6191 108.822L67.3422 107.135H66.0234Z",
    fill: "url(#paint12_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1795 111.446C75.2085 111.419 74.7053 111.305 74.4453 111.2C74.4453 111.295 74.4453 111.392 74.4487 111.494C74.4521 111.601 74.5331 111.688 74.631 111.688L79.9652 111.655C80.1357 111.653 80.2354 111.458 80.1611 111.304C79.462 111.359 77.6806 111.488 76.1795 111.446Z",
    fill: "url(#paint13_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1605 111.302C80.1538 111.289 80.1487 111.275 80.1386 111.262C79.6675 110.61 78.4669 109.313 76.0962 108.75L74.9581 108.715C74.9581 108.715 74.4515 109.585 74.4414 111.2C74.7014 111.305 75.2029 111.419 76.1756 111.446C77.6801 111.488 79.4615 111.359 80.1605 111.302Z",
    fill: "url(#paint14_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.75 107.008C74.7618 107.092 74.9189 108.367 74.9796 108.862C74.9931 108.979 75.0793 109.071 75.189 109.083C75.3832 109.106 75.6956 109.126 75.9708 109.071C76.1194 109.041 76.2258 108.9 76.2258 108.737V106.734L74.75 107.008Z",
    fill: "url(#paint15_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7827 82.2104C66.7827 82.2104 64.9625 98.2263 65.9739 108.237C65.9739 108.237 67.188 108.237 67.7942 108.036C67.7942 108.036 69.6854 92.3762 70.2983 87.8967C70.3219 87.7279 70.5651 87.7196 70.5989 87.8867C71.3537 91.6558 74.3188 106.44 74.6717 107.835C74.6717 107.835 75.6831 108.237 76.4919 107.835C76.4919 107.835 74.8743 86.4142 73.6602 82.6116L66.7827 82.2104Z",
    fill: "url(#paint16_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.144 63.5939C63.144 63.5939 70.8286 62.3921 76.8973 63.995L76.492 70.2012C76.492 70.2012 74.8744 78.8091 73.6603 82.6134C73.6603 82.6134 69.0084 83.414 66.7845 82.2122C66.7845 82.2122 64.9643 71.4013 63.9528 69.8C63.9528 69.7983 62.9414 65.5946 63.144 63.5939Z",
    fill: "url(#paint17_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4837 58.123L67.7188 63.2477C67.7188 63.2477 69.8581 64.2205 71.3559 63.2059L71.0334 59.5889L68.4837 58.123Z",
    fill: "url(#paint18_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7819 54.7853C71.8055 54.8287 72.2682 57.4128 72.5519 59.0124C72.6701 59.6726 72.1787 60.2877 71.5016 60.3278L70.8819 60.3646C69.7438 60.4314 68.7408 59.6291 68.5686 58.5126L68.1211 55.6143C68.1194 55.6143 71.196 53.7339 71.7819 54.7853Z",
    fill: "url(#paint19_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4487 55.621C67.2106 55.3285 67.0046 54.8555 67.5095 54.3591C68.0211 53.856 68.6037 53.9813 68.9718 54.1501C69.1356 54.2253 69.3365 54.1919 69.4513 54.0565C69.5037 53.9964 69.5797 53.9546 69.6928 53.9679C69.9072 53.9913 70.098 53.8509 70.1234 53.6403C70.1673 53.2776 70.3631 52.8497 71.0116 52.7244C72.202 52.4971 72.7963 53.6754 72.7744 54.5045C72.7524 55.3335 71.4489 55.5073 70.7076 55.3703C70.1639 55.27 69.6928 55.743 69.4817 56.0004C69.4057 56.094 69.377 56.2177 69.404 56.3347L69.5915 57.1353C69.4615 57.3844 69.3331 57.6384 69.1508 57.8507C69.0191 58.0045 68.8738 58.0881 68.7219 58.1232C68.5007 57.7137 67.8793 57.6451 67.5905 57.6351C67.4808 57.6318 67.3778 57.5833 67.3052 57.5014C67.0874 57.254 66.7463 56.7024 67.3997 56.1609C67.5618 56.0272 67.5804 55.7848 67.4487 55.621Z",
    fill: "url(#paint20_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9409 58.9805C68.9409 58.9805 68.9156 57.5347 68.3246 57.3993C67.7336 57.264 67.0954 57.6868 67.6019 58.5526C68.2301 59.6274 68.9409 58.9805 68.9409 58.9805Z",
    fill: "url(#paint21_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6019 70.5053C66.6019 70.5053 49.2368 65.8269 57.8585 53.7925L58.4411 54.6098C58.4411 54.6098 55.8424 62.7598 64.449 63.5337C64.4506 63.5354 66.6795 69.2267 66.6019 70.5053Z",
    fill: "url(#paint22_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8052 53.8559C57.8052 53.8559 57.6094 51.5326 58.7829 51.3387C59.9565 51.1448 60.3482 52.3065 60.5424 52.8881C60.7383 53.4681 58.7829 54.6298 58.3912 54.6298C58.0011 54.6298 57.8052 53.8559 57.8052 53.8559Z",
    fill: "url(#paint23_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8692 71.0869C72.8692 71.0869 90.2342 66.4085 81.6125 54.374L81.0299 55.1914C81.0299 55.1914 83.6286 63.3414 75.0221 64.1153C75.0204 64.1169 72.7915 69.8066 72.8692 71.0869Z",
    fill: "url(#paint24_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6689 54.436C81.6689 54.436 81.8647 52.1127 80.6912 51.9188C79.5176 51.7249 79.1259 52.8866 78.9317 53.4682C78.7358 54.0499 80.6912 55.2099 81.0829 55.2099C81.473 55.2115 81.6689 54.436 81.6689 54.436Z",
    fill: "url(#paint25_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4113 58.9187L56.797 58.546L56 50.5681L63.1561 51.7732L58.4113 58.9187Z",
    fill: "url(#paint26_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.937 35.8425C54.7816 36.4643 51.9026 48.6793 57.6994 52.1091C63.4962 55.5389 68.7611 45.8579 70.2707 38.445L54.937 35.8425Z",
    fill: "url(#paint27_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0617 62.213L52.0469 59.8997L52.3306 58.6963L62.3454 61.0096L62.0617 62.213Z",
    fill: "url(#paint28_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3468 61.0096L52.332 58.6963L55.184 57.9358L60.1298 59.0774L62.3468 61.0096Z",
    fill: "url(#paint29_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6227 33.9422C54.0654 33.8486 53.52 34.1478 53.412 34.6074L53.1908 35.5468C53.0827 36.0064 53.4491 36.4627 54.0063 36.5597L71.39 39.6101C71.9472 39.707 72.4909 39.4112 72.599 38.9532L72.8523 37.8801C72.9603 37.4205 72.5922 36.9675 72.035 36.8739L54.6227 33.9422Z",
    fill: "url(#paint30_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9098 54.1049C61.5096 54.0129 61.2243 53.682 61.2564 53.3327C61.2918 52.9566 61.6836 52.6992 62.131 52.7594C62.2171 52.7711 68.1186 53.4981 69.4002 50.5029C69.6164 49.9981 69.7684 49.3078 69.2635 48.8899C68.8481 48.5439 68.0578 48.4403 67.4246 48.6509C67.065 48.7696 66.6428 49.0253 66.6682 49.5702C66.6867 49.9513 66.3372 50.2488 65.8881 50.2355C65.4389 50.2221 65.0607 49.9012 65.0421 49.5217C64.9948 48.5356 65.628 47.7283 66.734 47.3622C67.9633 46.9561 69.4509 47.1951 70.3526 47.9439C70.8794 48.3818 71.6561 49.3696 70.9301 51.0628C70.2141 52.7376 68.4124 53.7957 65.7192 54.1233C63.7858 54.3573 62.0686 54.135 61.996 54.1266C61.9706 54.1182 61.9402 54.1116 61.9098 54.1049Z",
    fill: "url(#paint31_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9377 52.7261C56.3379 52.818 56.7415 52.6475 56.8681 52.3199C57.0049 51.9672 56.7668 51.5644 56.3396 51.4223C56.2586 51.3956 50.6391 49.4617 50.8282 46.2157C50.8603 45.6675 51.0325 44.9839 51.6708 44.8284C52.1993 44.6997 52.9541 44.9538 53.4269 45.4185C53.6953 45.6825 53.9605 46.0971 53.6937 46.5734C53.5079 46.9077 53.6869 47.3273 54.0955 47.5111C54.5042 47.695 54.9871 47.5746 55.1728 47.2403C55.6558 46.3762 55.4498 45.375 54.6207 44.5627C53.7004 43.6601 52.2584 43.2222 51.1152 43.4996C50.4466 43.6618 49.3085 44.2067 49.2021 46.0436C49.0957 47.8588 50.2389 49.5971 52.5066 51.0696C54.1344 52.1277 55.7756 52.6809 55.8449 52.7027C55.877 52.7093 55.9073 52.7194 55.9377 52.7261Z",
    fill: "url(#paint32_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4781 37.8718C68.4697 37.8718 68.4612 37.8718 68.4545 37.8701L66.9027 37.5977C66.8284 37.5843 66.7777 37.5141 66.7912 37.4389C66.8048 37.3653 66.8757 37.3152 66.9517 37.3286L68.5034 37.601C68.5777 37.6144 68.6284 37.6846 68.6149 37.7598C68.6014 37.825 68.544 37.8718 68.4781 37.8718Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3249 37.1431C64.3164 37.1431 64.308 37.1431 64.3012 37.1414L55.0277 35.5135C54.9534 35.5001 54.9027 35.4299 54.9162 35.3547C54.9298 35.2811 55.0007 35.231 55.0767 35.2443L64.3502 36.8723C64.4245 36.8857 64.4751 36.9559 64.4616 37.0311C64.4481 37.0963 64.3907 37.1431 64.3249 37.1431Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8964 50.9257C58.8812 50.9257 58.866 50.9224 58.8508 50.9174C57.2348 50.3457 56.2234 48.701 55.8435 46.03C55.5294 43.8254 55.7151 41.3734 55.9245 39.7053C55.9346 39.63 56.0022 39.5782 56.0782 39.5866C56.1541 39.5966 56.2065 39.6635 56.198 39.7387C55.8367 42.6019 55.3825 49.398 58.9436 50.66C59.0145 50.685 59.0517 50.7636 59.0264 50.8338C59.0044 50.8906 58.9521 50.9257 58.8964 50.9257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2501 38.557C56.2433 38.557 56.2349 38.557 56.2281 38.5553C56.1538 38.5436 56.1032 38.4734 56.115 38.3982C56.1792 38.0204 56.2231 37.8031 56.2248 37.7948C56.2399 37.7212 56.3126 37.6728 56.3869 37.6878C56.4611 37.7028 56.5101 37.7747 56.4949 37.8483C56.4949 37.8499 56.4493 38.0689 56.3869 38.4416C56.375 38.5085 56.3176 38.557 56.2501 38.557Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2506 54.5461C56.2506 54.5461 57.8041 53.8641 57.6048 55.0074C57.4056 56.1506 57.8227 56.9847 56.9362 57.0733C56.0497 57.1619 55.9501 55.3367 56.2506 54.5461Z",
    fill: "url(#paint33_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4122 63.159C67.2957 62.8732 67.0526 62.7027 66.7385 62.6559C66.3789 62.6024 65.7254 62.671 65.7507 63.1557C65.8267 64.5915 66.291 68.2202 68.9927 70.0722L69.5398 69.5289C69.1667 68.7785 68.8425 68.0012 68.5149 67.229C68.2312 66.5604 68.0421 65.8568 67.8057 65.1715C67.6892 64.8355 67.5777 64.5012 67.5338 64.1469C67.495 63.841 67.5321 63.505 67.4325 63.2109C67.4241 63.1941 67.419 63.1758 67.4122 63.159Z",
    fill: "url(#paint34_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0963 63.159C72.2128 62.8732 72.456 62.7027 72.7701 62.6559C73.1297 62.6024 73.7832 62.671 73.7579 63.1557C73.6819 64.5915 73.2175 68.2202 70.5158 70.0722L69.9688 69.5289C70.3419 68.7785 70.6661 68.0012 70.9937 67.229C71.2774 66.5604 71.4665 65.8568 71.7029 65.1715C71.8194 64.8355 71.9308 64.5012 71.9747 64.1469C72.0136 63.841 71.9764 63.505 72.0761 63.2109C72.0828 63.1941 72.0896 63.1758 72.0963 63.159Z",
    fill: "url(#paint35_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9418 72.8835C71.2623 72.8835 72.3328 71.8238 72.3328 70.5167C72.3328 69.2095 71.2623 68.1499 69.9418 68.1499C68.6213 68.1499 67.5508 69.2095 67.5508 70.5167C67.5508 71.8238 68.6213 72.8835 69.9418 72.8835Z",
    fill: "url(#paint36_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M69.9843 72.2983C70.9551 72.2983 71.7421 71.5193 71.7421 70.5583C71.7421 69.5974 70.9551 68.8184 69.9843 68.8184C69.0135 68.8184 68.2266 69.5974 68.2266 70.5583C68.2266 71.5193 69.0135 72.2983 69.9843 72.2983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9315 70.8042C67.8876 70.8042 67.8504 70.7708 67.847 70.7274C67.8183 70.3964 67.8453 70.0872 67.9281 69.8114C67.9416 69.7663 67.9889 69.7412 68.0328 69.7546C68.0767 69.7679 68.1037 69.8147 68.0902 69.8582C68.0142 70.1139 67.9889 70.4014 68.0159 70.7123C68.0193 70.7591 67.9855 70.7992 67.9382 70.8026C67.9365 70.8042 67.9331 70.8042 67.9315 70.8042Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1936 69.5005C68.1784 69.5005 68.1649 69.4972 68.1514 69.4888C68.1109 69.4654 68.0974 69.4136 68.121 69.3752C68.6208 68.5394 69.5867 68.3689 69.6272 68.3623C69.6728 68.3556 69.7167 68.3857 69.7251 68.4308C69.7336 68.4759 69.7015 68.5194 69.6559 68.5277C69.6475 68.5294 68.7255 68.6932 68.2662 69.4604C68.2493 69.4855 68.2223 69.5005 68.1936 69.5005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7608 81.9431C28.7608 81.9431 28.7051 83.7633 30.3666 83.8953C32.0282 84.0274 33.5698 83.5844 33.5698 83.5844L33.7133 84.6759C33.7133 84.6759 30.3886 88.5453 27.4927 86.3607C24.5969 84.1761 25.0494 81.6439 25.225 80.9619C25.3989 80.2816 28.2002 81.5871 28.7608 81.9431Z",
    fill: "url(#paint37_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5386 74.4199C26.7615 74.5536 28.2744 74.9865 28.5784 78.1055C28.8823 81.2244 29.1474 82.0835 29.1474 82.0835L25.875 82.6301L26.5386 74.4199Z",
    fill: "url(#paint38_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6696 116.407C23.6696 116.407 23.4704 117.518 23.3742 118.62C23.3353 119.049 23.6713 119.424 24.107 119.442C25.5878 119.504 28.7556 119.623 29.892 119.572C30.0625 119.564 30.1739 119.392 30.1115 119.235C30.0591 119.103 29.9561 118.996 29.8261 118.937L24.5933 116.557L23.6696 116.407Z",
    fill: "url(#paint39_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5078 115.753L23.6665 117.084C23.6665 117.084 24.5834 117.507 25.2082 117.03L24.8283 115.548L23.5078 115.753Z",
    fill: "url(#paint40_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6289 90.7483C23.5597 91.096 23.2591 108.081 25.0929 115.693C25.1233 115.817 25.0591 115.945 24.9392 115.994C24.6573 116.108 24.1068 116.273 23.4449 116.295C23.2406 116.301 23.0565 116.169 22.9991 115.976C22.4757 114.209 19.9631 105.362 19.6355 96.9093C19.2691 87.4639 19.6355 96.5883 19.6355 96.5883L19.85 90.75L23.6289 90.7483Z",
    fill: "url(#paint41_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6506 116.987C17.6506 116.987 17.3349 117.548 17.0292 119.039C16.9735 119.308 17.1643 119.566 17.4412 119.594C17.9309 119.641 18.6823 119.703 19.2851 119.7C19.5637 119.698 19.7799 119.459 19.7461 119.185C19.6786 118.64 19.4709 117.747 18.8292 117.05L17.6506 116.987Z",
    fill: "url(#paint42_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.375 115.277L17.7482 117.288C17.7482 117.288 18.1163 117.558 18.8457 117.363L18.6684 115.198L17.375 115.277Z",
    fill: "url(#paint43_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3662 91.2697C14.8667 100.232 16.6921 113.42 17.3067 116C17.3439 116.159 17.4739 116.28 17.6343 116.306C17.9095 116.352 18.362 116.388 18.8078 116.26C18.9615 116.216 19.0696 116.077 19.0763 115.92C19.159 113.833 19.0105 101.023 20.4086 95.9598C20.4795 95.7024 20.6382 95.4801 20.856 95.3246L23.5695 93.4158L23.7772 90.3303L16.3662 91.2697Z",
    fill: "url(#paint44_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9279 74.2895C21.433 74.216 16.4721 75.4579 16.4721 75.4579C15.1313 83.1984 16.2373 92.1256 16.2373 92.1256C19.7175 93.0299 23.6433 91.574 23.6433 91.574C24.2225 88.3398 26.9208 79.2337 26.9208 79.2337C27.9491 75.8289 27.3159 74.3112 25.9279 74.2895Z",
    fill: "url(#paint45_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1961 79.7668L16.4721 75.4578C16.4721 75.4578 12.2726 78.2825 11.582 81.8628C12.3757 81.9213 13.7062 82.1386 15.1195 82.8439C15.7561 81.4232 18.1961 79.7668 18.1961 79.7668Z",
    fill: "url(#paint46_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.372 70.6758L19.9418 74.7708C19.9182 74.8394 19.9469 74.9146 20.0094 74.948C20.3994 75.162 21.8043 75.7787 23.4962 74.7157C23.6718 74.6054 23.7934 74.4249 23.8187 74.2193L24.2814 70.6758H21.372Z",
    fill: "url(#paint47_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4862 66.885C24.4862 66.885 26.0565 69.8117 25.8556 70.9934C25.6546 72.1752 23.7077 72.0916 22.0074 71.1305L20.8203 67.9698L24.4862 66.885Z",
    fill: "url(#paint48_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0793 69.5793C22.1486 69.5492 22.1739 69.4657 22.1317 69.4021C22.005 69.2116 21.7703 68.8238 21.6943 68.4845C21.6943 68.4845 21.4124 68.3057 22.4137 68.0683C23.415 67.831 24.9077 67.4633 25.2217 66.6192C25.5274 65.7968 24.7236 63.7292 23.442 65.3773C23.393 65.4408 23.2968 65.4408 23.2495 65.379C23.0384 65.1082 22.4863 64.5466 21.7197 64.8875C21.002 65.2068 20.921 65.7266 20.9311 65.9907C20.9345 66.0676 20.8636 66.1278 20.7876 66.1127C20.4246 66.0442 19.5533 65.9857 19.1463 66.8699C18.812 67.5986 19.0298 68.0115 19.2274 68.2121C19.2915 68.2773 19.2628 68.3859 19.175 68.411C18.9369 68.4828 18.6279 68.6834 18.6583 69.2367C18.7005 70.0022 19.5651 69.9337 19.8116 69.8986C19.8521 69.8936 19.8927 69.9069 19.9197 69.937C20.1307 70.1677 21.0814 71.1488 22.1097 71.2675C22.1992 71.2775 22.2685 71.1906 22.2381 71.107L21.7923 69.8267C21.772 69.7665 21.8007 69.7013 21.8581 69.6763L22.0793 69.5793Z",
    fill: "url(#paint49_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2595 69.7597C22.2595 69.7597 21.1417 69.0009 21.059 69.6394C20.9779 70.2796 22.0654 70.5654 22.6057 70.328L22.2595 69.7597Z",
    fill: "url(#paint50_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1758 75.0567C18.985 74.7759 18.6524 74.6388 18.2505 74.6455C17.7895 74.6539 16.9773 74.8427 17.0837 75.3492C17.3995 76.8501 18.5376 80.5975 22.2186 82.0701L22.8248 81.3998C22.2406 80.6744 21.7137 79.9122 21.1835 79.1551C20.7242 78.4999 20.3798 77.7912 19.9762 77.1109C19.7787 76.7766 19.5878 76.444 19.4781 76.0779C19.3835 75.762 19.3785 75.401 19.2079 75.1085C19.1978 75.0884 19.1877 75.0717 19.1758 75.0567Z",
    fill: "url(#paint51_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8484 74.3062C23.9058 73.9552 24.0949 73.7245 24.3668 73.6343C24.6775 73.529 25.2701 73.5323 25.3259 74.1056C25.4897 75.8038 25.6602 80.1312 23.5546 82.6317L22.9805 82.0584C23.1915 81.1308 23.3553 80.178 23.5225 79.2303C23.666 78.4096 23.7217 77.5589 23.8231 76.7231C23.872 76.3136 23.9176 75.9075 23.899 75.4846C23.8838 75.1202 23.796 74.7308 23.8383 74.3714C23.8416 74.348 23.845 74.3263 23.8484 74.3062Z",
    fill: "url(#paint52_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5758 84.4234C23.7611 84.4234 24.722 83.4723 24.722 82.299C24.722 81.1257 23.7611 80.1746 22.5758 80.1746C21.3905 80.1746 20.4297 81.1257 20.4297 82.299C20.4297 83.4723 21.3905 84.4234 22.5758 84.4234Z",
    fill: "url(#paint53_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M22.6123 83.8969C23.4833 83.8969 24.1894 83.198 24.1894 82.3358C24.1894 81.4736 23.4833 80.7747 22.6123 80.7747C21.7413 80.7747 21.0352 81.4736 21.0352 82.3358C21.0352 83.198 21.7413 83.8969 22.6123 83.8969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.77 82.565C20.7261 82.565 20.689 82.5315 20.6856 82.4881C20.6602 82.1889 20.6839 81.9114 20.7582 81.664C20.7717 81.6206 20.819 81.5938 20.8629 81.6072C20.9068 81.6206 20.9338 81.6674 20.9203 81.7109C20.8527 81.9398 20.8291 82.1956 20.8527 82.4747C20.8561 82.5215 20.8224 82.5616 20.7751 82.565C20.7751 82.565 20.7717 82.565 20.77 82.565Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0022 81.3931C20.987 81.3931 20.9735 81.3898 20.96 81.3815C20.9195 81.3581 20.906 81.3062 20.9296 81.2678C21.3804 80.514 22.2517 80.3602 22.2889 80.3552C22.3345 80.3485 22.3784 80.3786 22.3868 80.4237C22.3953 80.4688 22.3632 80.5123 22.3176 80.5206C22.3091 80.5223 21.4851 80.6677 21.0765 81.3547C21.0596 81.3798 21.0309 81.3931 21.0022 81.3931Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9273 84.4836L21.3255 82.3709C21.3255 82.3709 23.9326 82.1754 24.245 82.5665C24.5573 82.9576 23.377 84.0574 23.377 84.0574L21.7814 83.9872C21.7814 83.9872 20.6044 86.0548 20.0709 85.7088C19.5356 85.3628 19.9273 84.4836 19.9273 84.4836Z",
    fill: "url(#paint54_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1202 82.8439C15.1202 82.8439 15.0645 84.6641 16.726 84.7961C18.3875 84.9282 19.9292 84.4852 19.9292 84.4852L20.0727 85.5767C20.0727 85.5767 16.748 89.4461 13.8521 87.2615C10.9562 85.0769 11.4088 82.5447 11.5844 81.8627C11.7583 81.1808 14.5596 82.4878 15.1202 82.8439Z",
    fill: "url(#paint55_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3878 83.7751C33.3878 83.7751 33.1091 83.0496 34.2979 83.0246C35.4849 82.9995 35.8902 82.4496 35.9898 82.7989C36.0911 83.1483 35.4343 83.4993 35.4343 83.4993C35.4343 83.4993 36.748 83.999 37.2528 83.6246C37.7577 83.2502 37.5568 82.6986 37.8337 82.824C38.1123 82.9494 37.859 84.6492 37.1769 85.0504C36.4947 85.4498 34.1814 85.3479 33.6326 84.7612L33.3878 83.7751Z",
    fill: "url(#paint56_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.961 39.8424C122.702 39.448 122.261 39.1855 121.787 39.1855H85.1117L83.9297 47.7985L119.011 47.7685C119.653 47.7685 120.235 47.4007 120.499 46.8224L123.062 41.1729C123.256 40.7417 123.217 40.2369 122.961 39.8424Z",
    fill: "url(#paint57_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4707 36.9274C94.3255 36.7068 94.0773 36.5747 93.8121 36.5747H82.5512C81.7981 36.5747 81.1142 37.0126 80.8069 37.6946L75.7058 48.9919C75.5961 49.236 75.618 49.4934 75.7649 49.7173C75.9118 49.9413 76.1634 50.0516 76.4336 50.0516H88.1758C88.6739 50.0516 89.123 49.7859 89.324 49.3363L94.5298 37.6578C94.6395 37.4121 94.6159 37.148 94.4707 36.9274Z",
    fill: "url(#paint58_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M88.8622 44.822C89.6943 42.7783 88.6952 40.4538 86.6305 39.6302C84.5659 38.8065 82.2176 39.7956 81.3855 41.8393C80.5534 43.883 81.5526 46.2075 83.6173 47.0312C85.6819 47.8548 88.0302 46.8658 88.8622 44.822Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3745 41.8364C86.3644 42.5117 85.8021 43.2337 85.1182 43.2237C84.4361 43.2137 83.8924 42.4766 83.9025 41.8013C83.9126 41.126 84.4715 40.6547 85.1537 40.6647C85.8376 40.6747 86.383 41.1611 86.3745 41.8364Z",
    fill: "url(#paint59_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5461 45.8027L86.5618 45.8445C86.8793 45.8495 87.163 45.6489 87.2643 45.3514L87.4331 44.8516C87.5564 44.4856 87.369 44.0844 87.0059 43.9474C85.7851 43.4861 84.5153 43.5245 83.2084 43.9357C82.8419 44.051 82.6343 44.4338 82.7305 44.8015L82.8487 45.2595C82.9314 45.5754 83.2168 45.7977 83.5461 45.8027Z",
    fill: "url(#paint60_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.822 46.5183L97.0267 46.1656C96.9642 46.1389 96.8933 46.1422 96.8359 46.1773L96.0912 46.6252C95.946 46.7122 95.7619 46.5968 95.7805 46.4297L95.8734 45.5722C95.8801 45.5054 95.8548 45.4402 95.8025 45.3967L95.1422 44.8351C95.0122 44.7248 95.0679 44.5159 95.2334 44.4808L96.0861 44.3036C96.152 44.2902 96.2077 44.2451 96.233 44.1833L96.5691 43.3876C96.6349 43.2322 96.8527 43.2188 96.9372 43.3642L97.3711 44.1114C97.4049 44.1699 97.4657 44.2083 97.5332 44.2133L98.4011 44.2835C98.5717 44.2969 98.6511 44.4975 98.5362 44.6228L97.952 45.2613C97.9064 45.3115 97.8878 45.38 97.9047 45.4452L98.1056 46.2843C98.1445 46.4497 97.9773 46.5885 97.822 46.5183Z",
    fill: "url(#paint61_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0201 45.3499C95.9964 45.3115 95.9677 45.2764 95.934 45.2463L95.5034 44.8786C95.4578 44.8401 95.4392 44.7799 95.4544 44.7231C95.4696 44.6663 95.5152 44.6228 95.5726 44.6111L96.1298 44.4958C96.2599 44.4691 96.3696 44.3805 96.4203 44.2585L96.6398 43.7386C96.6634 43.6835 96.7141 43.6484 96.7732 43.645C96.8323 43.6417 96.888 43.6718 96.9184 43.7219L97.0636 43.971L97.0248 43.9927L96.8796 43.7436C96.8576 43.7069 96.8188 43.6851 96.7766 43.6885C96.7327 43.6918 96.6972 43.7169 96.6803 43.7553L96.4608 44.2752C96.4034 44.4106 96.2835 44.5092 96.1383 44.5393L95.5811 44.6546C95.5389 44.6629 95.5068 44.693 95.4966 44.7348C95.4865 44.7766 95.4983 44.8184 95.5321 44.8468L95.9627 45.2145C96.0015 45.248 96.0336 45.2864 96.0589 45.3282L96.0201 45.3499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1647 46.3245C96.136 46.3245 96.109 46.3161 96.0837 46.3011C96.033 46.2693 96.006 46.2125 96.0127 46.154L96.06 45.7261L96.1039 45.7311L96.0566 46.159C96.0516 46.2024 96.0718 46.2409 96.1073 46.2643C96.1444 46.2877 96.1884 46.2877 96.2255 46.266L96.7118 45.9735C96.8367 45.8982 96.9955 45.8882 97.1289 45.9484L97.6456 46.1774C97.6844 46.1958 97.7283 46.1891 97.7621 46.1623C97.7959 46.1356 97.8094 46.0938 97.7992 46.052L97.6692 45.5038C97.6354 45.3617 97.6743 45.2113 97.7739 45.1026L98.1555 44.6848C98.1842 44.653 98.1927 44.6095 98.1775 44.5694C98.1623 44.5293 98.1268 44.5042 98.0829 44.4992L97.5155 44.4524C97.4564 44.4474 97.4007 44.4324 97.3484 44.4056L97.3686 44.3672C97.4159 44.3906 97.4666 44.4056 97.5189 44.409L98.0863 44.4558C98.1454 44.4608 98.196 44.4976 98.218 44.5527C98.2399 44.6079 98.2281 44.6697 98.1893 44.7132L97.8077 45.131C97.7182 45.228 97.6827 45.3634 97.7131 45.4921L97.8431 46.0403C97.8566 46.0971 97.8364 46.1573 97.7908 46.1941C97.7452 46.2325 97.6827 46.2409 97.627 46.2158L97.1086 45.9852C96.9887 45.9317 96.8452 45.94 96.7321 46.0086L96.2458 46.3011C96.2221 46.3178 96.1934 46.3245 96.1647 46.3245Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0654 43.9774L97.0273 43.999L97.113 44.1469L97.1511 44.1253L97.0654 43.9774Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.451 46.5835L101.656 46.2308C101.593 46.204 101.522 46.2074 101.465 46.2425L100.72 46.6904C100.575 46.7773 100.391 46.662 100.409 46.4949L100.502 45.6374C100.509 45.5706 100.484 45.5054 100.431 45.4619L99.7711 44.9003C99.6411 44.79 99.6968 44.5811 99.8623 44.546L100.715 44.3688C100.781 44.3554 100.837 44.3103 100.862 44.2484L101.198 43.4528C101.264 43.2974 101.482 43.284 101.566 43.4294L102 44.1766C102.034 44.2351 102.095 44.2735 102.162 44.2785L103.03 44.3487C103.201 44.3621 103.28 44.5627 103.165 44.688L102.581 45.3265C102.535 45.3767 102.517 45.4452 102.534 45.5104L102.735 46.3495C102.773 46.5149 102.606 46.652 102.451 46.5835Z",
    fill: "url(#paint62_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.649 45.4151C100.627 45.3766 100.597 45.3415 100.563 45.3114L100.132 44.9437C100.087 44.9053 100.068 44.8451 100.083 44.7883C100.099 44.7314 100.144 44.688 100.202 44.6763L100.759 44.5609C100.889 44.5342 100.999 44.4456 101.049 44.3236L101.269 43.8038C101.292 43.7486 101.343 43.7135 101.402 43.7085C101.461 43.7052 101.517 43.7352 101.547 43.7854L101.693 44.0344L101.654 44.0562L101.508 43.8071C101.487 43.7703 101.448 43.7486 101.404 43.752C101.36 43.7553 101.324 43.7804 101.308 43.8188L101.088 44.3386C101.031 44.474 100.911 44.5726 100.766 44.6027L100.208 44.7181C100.166 44.7264 100.134 44.7565 100.124 44.7983C100.114 44.8401 100.126 44.8819 100.159 44.9103L100.59 45.278C100.629 45.3114 100.661 45.3499 100.686 45.3917L100.649 45.4151Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.794 46.3894C100.765 46.3894 100.738 46.3811 100.713 46.366C100.662 46.3343 100.635 46.2775 100.642 46.219L100.689 45.7911L100.733 45.7961L100.686 46.224C100.68 46.2674 100.701 46.3059 100.736 46.3293C100.773 46.3527 100.817 46.3527 100.854 46.3309L101.341 46.0384C101.466 45.9632 101.624 45.9532 101.758 46.0134L102.276 46.244C102.315 46.2624 102.359 46.2557 102.393 46.229C102.426 46.2022 102.44 46.1604 102.43 46.1187L102.3 45.5704C102.266 45.4284 102.305 45.2779 102.404 45.1693L102.786 44.7514C102.815 44.7197 102.823 44.6762 102.808 44.6361C102.793 44.596 102.757 44.5709 102.714 44.5659L102.146 44.5191C102.087 44.5141 102.031 44.499 101.979 44.4723L101.999 44.4338C102.047 44.4572 102.097 44.4723 102.15 44.4756L102.717 44.5224C102.776 44.5274 102.827 44.5642 102.849 44.6194C102.871 44.6745 102.859 44.7364 102.82 44.7798L102.438 45.1977C102.349 45.2946 102.313 45.43 102.344 45.5587L102.474 46.107C102.487 46.1638 102.467 46.224 102.421 46.2607C102.376 46.2992 102.313 46.3075 102.258 46.2825L101.739 46.0518C101.619 45.9983 101.476 46.0067 101.363 46.0752L100.876 46.3677C100.851 46.3811 100.822 46.3894 100.794 46.3894Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.694 44.0392L101.656 44.0608L101.742 44.2087L101.78 44.1871L101.694 44.0392Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.123 46.6486L106.327 46.296C106.265 46.2692 106.194 46.2726 106.137 46.3077L105.392 46.7556C105.247 46.8425 105.063 46.7272 105.081 46.5601L105.174 45.7026C105.181 45.6357 105.156 45.5706 105.103 45.5271L104.443 44.9655C104.313 44.8552 104.369 44.6462 104.534 44.6111L105.387 44.434C105.453 44.4206 105.508 44.3755 105.534 44.3136L105.87 43.518C105.936 43.3626 106.154 43.3492 106.238 43.4946L106.672 44.2418C106.706 44.3003 106.766 44.3387 106.834 44.3437L107.702 44.4139C107.872 44.4273 107.952 44.6279 107.837 44.7532L107.253 45.3917C107.207 45.4419 107.19 45.5104 107.205 45.5756L107.406 46.4146C107.445 46.5801 107.278 46.7172 107.123 46.6486Z",
    fill: "url(#paint63_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.321 45.4802C105.297 45.4418 105.269 45.4067 105.235 45.3766L104.804 45.0089C104.759 44.9705 104.74 44.9103 104.755 44.8534C104.77 44.7966 104.816 44.7532 104.873 44.7415L105.431 44.6261C105.561 44.5994 105.67 44.5108 105.721 44.3888L105.941 43.869C105.964 43.8138 106.015 43.7787 106.074 43.7737C106.133 43.7703 106.189 43.8004 106.219 43.8506L106.364 44.0996L106.326 44.1214L106.18 43.8723C106.158 43.8355 106.12 43.8138 106.077 43.8171C106.033 43.8205 105.998 43.8456 105.981 43.884L105.762 44.4038C105.704 44.5392 105.584 44.6378 105.439 44.6679L104.882 44.7832C104.84 44.7916 104.808 44.8217 104.797 44.8635C104.787 44.9053 104.799 44.9471 104.833 44.9755L105.263 45.3432C105.302 45.3766 105.334 45.4151 105.36 45.4568L105.321 45.4802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.465 46.4548C105.437 46.4548 105.41 46.4465 105.384 46.4298C105.334 46.398 105.307 46.3412 105.314 46.2827L105.361 45.8548L105.405 45.8598L105.357 46.2877C105.352 46.3311 105.373 46.3696 105.408 46.393C105.445 46.4164 105.489 46.4164 105.526 46.3947L106.013 46.1022C106.138 46.0269 106.296 46.0169 106.43 46.0771L106.948 46.3077C106.989 46.3261 107.031 46.3194 107.065 46.2927C107.098 46.266 107.112 46.2242 107.102 46.1824L106.972 45.6341C106.938 45.4921 106.977 45.3416 107.076 45.233L107.458 44.8151C107.487 44.7834 107.495 44.7399 107.48 44.6998C107.465 44.6597 107.429 44.6346 107.385 44.6296L106.818 44.5828C106.759 44.5778 106.703 44.5627 106.651 44.536L106.671 44.4976C106.718 44.521 106.769 44.536 106.821 44.5393L107.389 44.5861C107.448 44.5912 107.499 44.6279 107.52 44.6831C107.542 44.7382 107.531 44.8001 107.492 44.8435L107.11 45.2614C107.021 45.3584 106.985 45.4937 107.016 45.6224L107.146 46.1707C107.159 46.2275 107.139 46.2877 107.093 46.3245C107.048 46.3629 106.985 46.3713 106.929 46.3462L106.411 46.1155C106.291 46.062 106.148 46.0704 106.035 46.1389L105.548 46.4314C105.523 46.4465 105.494 46.4548 105.465 46.4548Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.366 44.1046L106.328 44.1262L106.414 44.2741L106.452 44.2525L106.366 44.1046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.877 46.7155L111.081 46.3629C111.019 46.3361 110.948 46.3395 110.891 46.3746L110.146 46.8225C110.001 46.9094 109.817 46.7941 109.835 46.6269L109.928 45.7695C109.935 45.7026 109.91 45.6374 109.857 45.594L109.197 45.0324C109.067 44.9221 109.123 44.7131 109.288 44.678L110.141 44.5009C110.207 44.4875 110.262 44.4424 110.288 44.3805L110.624 43.5849C110.69 43.4295 110.907 43.4161 110.992 43.5615L111.426 44.3086C111.46 44.3671 111.52 44.4056 111.588 44.4106L112.456 44.4808C112.626 44.4942 112.706 44.6947 112.591 44.8201L112.007 45.4586C111.961 45.5087 111.943 45.5773 111.959 45.6425L112.16 46.4815C112.201 46.647 112.032 46.7841 111.877 46.7155Z",
    fill: "url(#paint64_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.075 45.5454C110.051 45.507 110.022 45.4719 109.989 45.4418L109.558 45.0741C109.512 45.0356 109.494 44.9755 109.509 44.9186C109.524 44.8618 109.57 44.8183 109.627 44.8066L110.185 44.6913C110.315 44.6646 110.424 44.576 110.475 44.454L110.694 43.9341C110.718 43.879 110.769 43.8439 110.828 43.8389C110.887 43.8355 110.943 43.8656 110.973 43.9158L111.118 44.1648L111.079 44.1865L110.934 43.9375C110.912 43.9007 110.873 43.879 110.831 43.8823C110.787 43.8857 110.752 43.9107 110.735 43.9492L110.515 44.469C110.458 44.6044 110.338 44.703 110.193 44.7331L109.636 44.8484C109.594 44.8568 109.561 44.8869 109.551 44.9287C109.541 44.9704 109.553 45.0122 109.587 45.0407L110.017 45.4084C110.056 45.4401 110.088 45.4802 110.114 45.522L110.075 45.5454Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.215 46.5201C110.187 46.5201 110.16 46.5117 110.134 46.4967C110.084 46.4649 110.057 46.4081 110.064 46.3496L110.111 45.9217L110.155 45.9267L110.107 46.3546C110.102 46.398 110.123 46.4365 110.158 46.4599C110.194 46.4833 110.239 46.4833 110.276 46.4616L110.763 46.169C110.888 46.0938 111.046 46.0838 111.18 46.144L111.698 46.3746C111.737 46.393 111.781 46.3863 111.815 46.3596C111.848 46.3328 111.862 46.2911 111.852 46.2493L111.722 45.701C111.688 45.559 111.727 45.4085 111.826 45.2999L112.208 44.882C112.237 44.8503 112.245 44.8068 112.23 44.7667C112.215 44.7266 112.179 44.7015 112.135 44.6965L111.568 44.6497C111.509 44.6447 111.453 44.6296 111.401 44.6029L111.421 44.5645C111.468 44.5879 111.519 44.6029 111.571 44.6062L112.139 44.653C112.198 44.6581 112.249 44.6948 112.27 44.75C112.292 44.8051 112.281 44.867 112.242 44.9104L111.86 45.3283C111.771 45.4253 111.735 45.5606 111.766 45.6893L111.896 46.2376C111.909 46.2944 111.889 46.3546 111.843 46.3914C111.798 46.4298 111.735 46.4382 111.679 46.4131L111.161 46.1824C111.041 46.1289 110.898 46.1373 110.785 46.2058L110.298 46.4983C110.273 46.5134 110.244 46.5217 110.215 46.5201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.124 44.1717L111.086 44.1934L111.172 44.3413L111.21 44.3197L111.124 44.1717Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.826 46.7155L116.031 46.3629C115.968 46.3361 115.897 46.3395 115.84 46.3746L115.095 46.8225C114.95 46.9094 114.766 46.7941 114.784 46.6269L114.877 45.7695C114.884 45.7026 114.859 45.6374 114.806 45.594L114.146 45.0324C114.016 44.9221 114.072 44.7131 114.237 44.678L115.09 44.5009C115.156 44.4875 115.212 44.4424 115.237 44.3805L115.573 43.5849C115.639 43.4295 115.857 43.4161 115.941 43.5615L116.375 44.3086C116.409 44.3671 116.47 44.4056 116.537 44.4106L117.405 44.4808C117.576 44.4942 117.655 44.6947 117.54 44.8201L116.956 45.4586C116.91 45.5087 116.892 45.5773 116.909 45.6425L117.11 46.4815C117.15 46.647 116.983 46.7841 116.826 46.7155Z",
    fill: "url(#paint65_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.024 45.5454C115.002 45.507 114.972 45.4719 114.938 45.4418L114.507 45.0741C114.462 45.0356 114.443 44.9755 114.458 44.9186C114.474 44.8618 114.519 44.8183 114.577 44.8066L115.134 44.6913C115.264 44.6646 115.374 44.576 115.424 44.454L115.644 43.9341C115.667 43.879 115.718 43.8439 115.777 43.8389C115.836 43.8355 115.892 43.8656 115.922 43.9158L116.068 44.1648L116.029 44.1865L115.883 43.9408C115.862 43.9041 115.823 43.8823 115.78 43.8857C115.737 43.889 115.701 43.9141 115.684 43.9525L115.465 44.4724C115.407 44.6077 115.287 44.7064 115.142 44.7364L114.585 44.8518C114.543 44.8601 114.511 44.8902 114.501 44.932C114.49 44.9738 114.502 45.0156 114.536 45.044L114.967 45.4117C115.005 45.4435 115.038 45.4836 115.063 45.5254L115.024 45.5454Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.169 46.5201C115.14 46.5201 115.113 46.5117 115.088 46.4967C115.037 46.4649 115.01 46.4081 115.017 46.3496L115.064 45.9217L115.108 45.9267L115.061 46.3546C115.055 46.398 115.076 46.4365 115.111 46.4599C115.148 46.4833 115.192 46.4833 115.229 46.4616L115.716 46.169C115.841 46.0938 115.999 46.0838 116.133 46.144L116.651 46.3746C116.69 46.393 116.734 46.3863 116.768 46.3596C116.801 46.3328 116.815 46.2911 116.805 46.2493L116.675 45.701C116.641 45.559 116.68 45.4085 116.779 45.2999L117.161 44.882C117.19 44.8503 117.198 44.8068 117.183 44.7667C117.168 44.7266 117.132 44.7015 117.089 44.6965L116.521 44.6497C116.462 44.6447 116.406 44.6296 116.354 44.6029L116.374 44.5645C116.422 44.5879 116.472 44.6029 116.525 44.6062L117.092 44.653C117.151 44.6581 117.202 44.6948 117.224 44.75C117.246 44.8051 117.234 44.867 117.195 44.9104L116.813 45.3283C116.724 45.4253 116.688 45.5606 116.719 45.6893L116.849 46.2376C116.862 46.2944 116.842 46.3546 116.796 46.3914C116.751 46.4298 116.688 46.4382 116.633 46.4131L116.114 46.1824C115.994 46.1289 115.851 46.1373 115.738 46.2058L115.251 46.4983C115.226 46.5134 115.197 46.5217 115.169 46.5201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.065 44.1652L116.027 44.1868L116.113 44.3347L116.151 44.313L116.065 44.1652Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M120.347 42.0688C120.342 42.4683 119.953 42.7875 119.482 42.7808L96.4654 42.4599C95.9926 42.4532 95.6161 42.1239 95.6211 41.7245V41.686C95.6262 41.2865 96.0146 40.9673 96.4857 40.974L119.502 41.2949C119.975 41.3016 120.352 41.6309 120.347 42.0303V42.0688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7088 49.5569C79.7055 49.5569 79.7038 49.5569 79.7004 49.5569L76.9818 49.3848C76.8113 49.3731 76.6576 49.2795 76.5698 49.134C76.4837 48.987 76.4769 48.8081 76.5512 48.656L77.9477 45.7928C77.9781 45.731 78.0541 45.7042 78.1165 45.7343C78.179 45.7644 78.206 45.8396 78.1756 45.9015L76.7792 48.7647C76.742 48.8415 76.7454 48.9335 76.7893 49.007C76.8332 49.0806 76.9109 49.129 76.9987 49.134L79.7173 49.3062C79.7865 49.3112 79.8405 49.3697 79.8355 49.4399C79.8304 49.5051 79.7747 49.5569 79.7088 49.5569Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7378 41.1912C91.7141 41.1912 91.6905 41.1862 91.6668 41.1762C91.5824 41.1377 91.5453 41.0375 91.5841 40.9539L92.8522 38.2311C92.9096 38.1074 92.9012 37.962 92.8269 37.8467C92.8049 37.8116 92.7357 37.6795 92.4892 37.6795H89.161C89.0682 37.6795 88.9922 37.6043 88.9922 37.5124C88.9922 37.4204 89.0682 37.3452 89.161 37.3452H92.4892C92.8455 37.3452 93.0245 37.5307 93.1106 37.6661C93.2473 37.8784 93.2642 38.1325 93.1562 38.3598L91.888 41.0876C91.8627 41.1494 91.8003 41.1912 91.7378 41.1912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.522 60.4348C138.306 60.1055 137.938 59.9116 137.541 59.9116H106.867L105.879 67.0888L135.219 67.0504C135.756 67.0504 136.242 66.7362 136.462 66.2514L138.606 61.5363C138.77 61.1769 138.738 60.7641 138.522 60.4348Z",
    fill: "url(#paint66_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.693 57.9694C114.572 57.7856 114.364 57.6736 114.143 57.6736H104.724C104.094 57.6736 103.522 58.0396 103.265 58.6096L98.9999 68.0583C98.9071 68.2622 98.9256 68.4728 99.0489 68.66C99.1722 68.8472 99.3816 68.9358 99.6078 68.9358H109.43C109.846 68.9358 110.224 68.7185 110.391 68.3408L114.746 58.5745C114.835 58.3739 114.815 58.1533 114.693 57.9694Z",
    fill: "url(#paint67_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M110.241 63.3699C110.214 65.2119 108.684 66.6844 106.823 66.6593C104.963 66.6326 103.475 65.1183 103.5 63.2763C103.527 61.4344 105.057 59.9618 106.918 59.9869C108.779 60.012 110.266 61.5263 110.241 63.3699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.918 62.0762C107.91 62.6412 107.439 63.2446 106.868 63.2362C106.297 63.2279 105.843 62.6111 105.852 62.0462C105.86 61.4812 106.328 61.0867 106.899 61.0951C107.471 61.1035 107.927 61.5113 107.918 62.0762Z",
    fill: "url(#paint68_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.557 65.3941L108.079 65.4292C108.345 65.4326 108.583 65.2671 108.667 65.0164L108.809 64.5985C108.912 64.2926 108.757 63.9567 108.451 63.8414C107.429 63.4552 106.367 63.4887 105.275 63.8313C104.969 63.9266 104.795 64.2475 104.875 64.5551L104.974 64.9378C105.042 65.2036 105.282 65.3891 105.557 65.3941Z",
    fill: "url(#paint69_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.498 65.9926L116.832 65.6967C116.78 65.6733 116.721 65.6767 116.672 65.7067L116.049 66.0811C115.927 66.1547 115.774 66.0577 115.789 65.9173L115.866 65.2003C115.873 65.1451 115.851 65.09 115.807 65.0532L115.255 64.5835C115.147 64.4916 115.193 64.3161 115.333 64.2877L116.045 64.1406C116.101 64.1289 116.147 64.0921 116.169 64.0403L116.451 63.3751C116.506 63.2447 116.687 63.233 116.758 63.3567L117.121 63.9818C117.15 64.0303 117.2 64.062 117.256 64.067L117.982 64.1255C118.124 64.1372 118.192 64.3044 118.095 64.4097L117.606 64.9446C117.567 64.9863 117.553 65.0432 117.565 65.0983L117.732 65.8003C117.768 65.9357 117.628 66.0494 117.498 65.9926Z",
    fill: "url(#paint70_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.991 65.0149C115.972 64.9814 115.947 64.953 115.918 64.928L115.557 64.6204C115.52 64.5887 115.503 64.5385 115.516 64.49C115.528 64.4416 115.567 64.4065 115.616 64.3964L116.082 64.2995C116.192 64.2761 116.281 64.2025 116.325 64.1006L116.509 63.666C116.528 63.6209 116.572 63.5908 116.621 63.5875C116.671 63.5841 116.717 63.6092 116.742 63.6526L116.864 63.8616L116.832 63.88L116.71 63.671C116.692 63.6393 116.659 63.6226 116.624 63.6242C116.589 63.6259 116.558 63.6476 116.543 63.6811L116.359 64.1156C116.312 64.2293 116.21 64.3112 116.089 64.3363L115.623 64.4332C115.587 64.4399 115.56 64.465 115.552 64.5001C115.543 64.5352 115.553 64.5703 115.581 64.5937L115.942 64.9012C115.974 64.928 116.001 64.9614 116.021 64.9965L115.991 65.0149Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.112 65.8303C116.089 65.8303 116.065 65.8236 116.045 65.8102C116.002 65.7835 115.979 65.7367 115.986 65.6882L116.024 65.3305L116.062 65.3339L116.023 65.6915C116.019 65.7266 116.034 65.7601 116.065 65.7801C116.095 65.8002 116.132 65.8002 116.163 65.7818L116.57 65.5378C116.674 65.4743 116.808 65.4659 116.919 65.516L117.353 65.7083C117.387 65.7233 117.422 65.7183 117.451 65.6949C117.48 65.6715 117.492 65.6381 117.483 65.603L117.374 65.145C117.345 65.0263 117.377 64.9009 117.461 64.8107L117.78 64.4614C117.804 64.4346 117.811 64.3995 117.797 64.3661C117.784 64.3327 117.755 64.3109 117.718 64.3076L117.243 64.2691C117.195 64.2658 117.147 64.2524 117.103 64.229L117.12 64.1973C117.159 64.2173 117.203 64.229 117.247 64.2324L117.721 64.2708C117.77 64.2742 117.814 64.3059 117.831 64.3527C117.85 64.3995 117.84 64.4497 117.806 64.4864L117.487 64.8358C117.412 64.9177 117.382 65.0297 117.407 65.1383L117.517 65.5963C117.529 65.6447 117.512 65.6932 117.473 65.725C117.434 65.7567 117.382 65.7634 117.336 65.7434L116.902 65.5511C116.801 65.506 116.681 65.5144 116.588 65.5712L116.181 65.8152C116.161 65.8236 116.137 65.8303 116.112 65.8303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.86 63.8577L116.828 63.876L116.9 63.9992L116.932 63.9809L116.86 63.8577Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.369 66.046L120.703 65.7502C120.651 65.7268 120.592 65.7301 120.543 65.7602L119.92 66.1346C119.798 66.2082 119.645 66.1112 119.66 65.9708L119.738 65.2538C119.744 65.1986 119.722 65.1434 119.678 65.1067L119.126 64.637C119.018 64.5451 119.064 64.3696 119.204 64.3411L119.917 64.1941C119.972 64.1824 120.018 64.1456 120.04 64.0938L120.322 63.4285C120.377 63.2982 120.558 63.2865 120.629 63.4101L120.992 64.0353C121.021 64.0837 121.071 64.1155 121.127 64.1205L121.853 64.179C121.995 64.1907 122.063 64.3579 121.966 64.4632L121.477 64.998C121.438 65.0398 121.424 65.0966 121.436 65.1518L121.603 65.8538C121.641 65.9892 121.5 66.1045 121.369 66.046Z",
    fill: "url(#paint71_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.866 65.0681C119.847 65.0347 119.822 65.0063 119.793 64.9812L119.432 64.6736C119.395 64.6419 119.378 64.5917 119.391 64.5433C119.403 64.4948 119.442 64.4597 119.491 64.4497L119.957 64.3527C120.067 64.3293 120.156 64.2558 120.2 64.1538L120.384 63.7192C120.403 63.6741 120.447 63.644 120.496 63.6407C120.546 63.6373 120.592 63.6624 120.617 63.7059L120.739 63.9148L120.707 63.9332L120.585 63.7243C120.567 63.6925 120.534 63.6758 120.499 63.6775C120.464 63.6791 120.433 63.7008 120.418 63.7343L120.234 64.1689C120.187 64.2825 120.085 64.3644 119.964 64.3895L119.498 64.4864C119.462 64.4931 119.435 64.5182 119.427 64.5533C119.418 64.5884 119.428 64.6235 119.456 64.6469L119.817 64.9544C119.849 64.9812 119.876 65.0146 119.896 65.0497L119.866 65.0681Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.979 65.884C119.956 65.884 119.932 65.8773 119.912 65.8639C119.87 65.8372 119.846 65.7904 119.853 65.7419L119.892 65.3842L119.929 65.3876L119.89 65.7453C119.886 65.7804 119.902 65.8138 119.932 65.8338C119.962 65.8539 120 65.8539 120.03 65.8355L120.437 65.5915C120.542 65.528 120.675 65.5196 120.786 65.5698L121.22 65.762C121.254 65.777 121.29 65.772 121.318 65.7486C121.347 65.7252 121.359 65.6918 121.35 65.6567L121.241 65.1987C121.212 65.08 121.244 64.9547 121.328 64.8644L121.648 64.5151C121.671 64.4883 121.678 64.4532 121.665 64.4198C121.651 64.3864 121.622 64.3646 121.585 64.3613L121.111 64.3229C121.062 64.3195 121.014 64.3061 120.971 64.2827L120.987 64.251C121.026 64.271 121.07 64.2827 121.114 64.2861L121.589 64.3245C121.639 64.3279 121.681 64.3596 121.698 64.4064C121.717 64.4532 121.707 64.5034 121.673 64.5401L121.354 64.8895C121.28 64.9714 121.249 65.0834 121.274 65.192L121.384 65.65C121.396 65.6985 121.379 65.7469 121.34 65.7787C121.301 65.8104 121.249 65.8171 121.204 65.7971L120.77 65.6049C120.668 65.5597 120.548 65.5681 120.456 65.6249L120.049 65.8689C120.028 65.8773 120.003 65.884 119.979 65.884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.739 63.9168L120.707 63.9351L120.778 64.0583L120.811 64.04L120.739 63.9168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.275 66.1012L124.61 65.8054C124.557 65.782 124.498 65.7853 124.449 65.8154L123.826 66.1898C123.705 66.2633 123.551 66.1664 123.566 66.026L123.644 65.3089C123.651 65.2538 123.629 65.1986 123.585 65.1618L123.033 64.6922C122.924 64.6002 122.97 64.4247 123.11 64.3963L123.823 64.2492C123.879 64.2375 123.924 64.2008 123.946 64.1489L124.228 63.4837C124.284 63.3533 124.464 63.3416 124.535 63.4653L124.898 64.0904C124.927 64.1389 124.978 64.1707 125.033 64.1757L125.76 64.2342C125.901 64.2459 125.969 64.413 125.873 64.5183L125.383 65.0532C125.344 65.095 125.331 65.1518 125.342 65.207L125.51 65.909C125.545 66.0444 125.405 66.158 125.275 66.1012Z",
    fill: "url(#paint72_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.768 65.1233C123.75 65.0898 123.724 65.0614 123.696 65.0364L123.334 64.7288C123.297 64.6971 123.28 64.6469 123.294 64.5984C123.306 64.55 123.344 64.5149 123.393 64.5048L123.859 64.4079C123.969 64.3845 124.059 64.3109 124.102 64.209L124.287 63.7744C124.305 63.7293 124.349 63.6992 124.398 63.6959C124.449 63.6925 124.494 63.7176 124.52 63.761L124.641 63.97L124.609 63.9884L124.487 63.7794C124.469 63.7477 124.437 63.731 124.401 63.7326C124.366 63.7343 124.336 63.756 124.32 63.7895L124.136 64.224C124.089 64.3377 123.988 64.4196 123.866 64.4447L123.4 64.5416C123.365 64.5483 123.338 64.5734 123.329 64.6085C123.321 64.6436 123.331 64.6787 123.358 64.7021L123.719 65.0096C123.751 65.0364 123.778 65.0698 123.799 65.1049L123.768 65.1233Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.89 65.9389C123.866 65.9389 123.842 65.9322 123.822 65.9188C123.78 65.8921 123.756 65.8453 123.763 65.7968L123.802 65.4391L123.839 65.4425L123.8 65.8001C123.797 65.8352 123.812 65.8687 123.842 65.8887C123.873 65.9088 123.91 65.9088 123.94 65.8904L124.347 65.6464C124.452 65.5829 124.585 65.5745 124.697 65.6246L125.131 65.8169C125.164 65.8319 125.2 65.8269 125.229 65.8035C125.257 65.7801 125.269 65.7467 125.261 65.7116L125.151 65.2536C125.122 65.1349 125.154 65.0096 125.239 64.9193L125.558 64.57C125.581 64.5432 125.588 64.5081 125.575 64.4747C125.561 64.4413 125.532 64.4195 125.495 64.4162L125.021 64.3777C124.972 64.3744 124.925 64.361 124.881 64.3376L124.898 64.3042C124.936 64.3243 124.98 64.336 125.024 64.3393L125.499 64.3777C125.548 64.3811 125.592 64.4128 125.608 64.4596C125.627 64.5064 125.617 64.5566 125.583 64.5934L125.264 64.9427C125.19 65.0246 125.159 65.1366 125.185 65.2452L125.294 65.7032C125.306 65.7517 125.289 65.8001 125.25 65.8319C125.212 65.8637 125.159 65.8704 125.114 65.8503L124.68 65.6581C124.578 65.6129 124.459 65.6213 124.366 65.6781L123.959 65.9222C123.938 65.9322 123.913 65.9389 123.89 65.9389Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.646 63.9751L124.613 63.9934L124.685 64.1167L124.717 64.0984L124.646 63.9751Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M129.251 66.1561L128.586 65.8603C128.534 65.8369 128.475 65.8402 128.426 65.8703L127.803 66.2447C127.681 66.3183 127.527 66.2213 127.543 66.0809L127.62 65.3639C127.627 65.3087 127.605 65.2535 127.561 65.2168L127.009 64.7471C126.901 64.6552 126.947 64.4797 127.087 64.4513L127.799 64.3042C127.855 64.2925 127.901 64.2557 127.923 64.2039L128.205 63.5386C128.26 63.4083 128.441 63.3966 128.512 63.5203L128.875 64.1454C128.904 64.1938 128.954 64.2256 129.01 64.2306L129.736 64.2891C129.878 64.3008 129.945 64.468 129.849 64.5733L129.36 65.1081C129.321 65.1499 129.307 65.2067 129.319 65.2619L129.486 65.9639C129.523 66.0993 129.382 66.2146 129.251 66.1561Z",
    fill: "url(#paint73_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.749 65.1782C127.73 65.1448 127.705 65.1164 127.676 65.0913L127.315 64.7837C127.278 64.752 127.261 64.7018 127.274 64.6534C127.286 64.6049 127.325 64.5698 127.374 64.5598L127.84 64.4628C127.95 64.4394 128.039 64.3659 128.083 64.2639L128.267 63.8293C128.286 63.7842 128.329 63.7541 128.378 63.7508C128.429 63.7474 128.475 63.7725 128.5 63.816L128.622 64.0249L128.59 64.0433L128.468 63.8344C128.449 63.8026 128.417 63.7859 128.382 63.7876C128.346 63.7892 128.316 63.811 128.301 63.8444L128.117 64.279C128.069 64.3926 127.968 64.4745 127.847 64.4996L127.381 64.5965C127.345 64.6032 127.318 64.6283 127.31 64.6634C127.301 64.6985 127.311 64.7336 127.338 64.757L127.7 65.0645C127.732 65.0913 127.759 65.1247 127.779 65.1598L127.749 65.1782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.866 65.9941C127.842 65.9941 127.819 65.9874 127.799 65.974C127.756 65.9473 127.733 65.9005 127.739 65.852L127.778 65.4943L127.815 65.4977L127.777 65.8554C127.773 65.8905 127.788 65.9239 127.819 65.944C127.849 65.964 127.886 65.964 127.917 65.9456L128.324 65.7016C128.428 65.6381 128.562 65.6297 128.673 65.6799L129.107 65.8721C129.141 65.8871 129.176 65.8821 129.205 65.8587C129.234 65.8353 129.246 65.8019 129.237 65.7668L129.127 65.3088C129.099 65.1901 129.131 65.0648 129.215 64.9745L129.534 64.6252C129.558 64.5984 129.565 64.5633 129.551 64.5299C129.538 64.4965 129.509 64.4747 129.472 64.4714L128.997 64.433C128.948 64.4296 128.901 64.4162 128.857 64.3928L128.874 64.3611C128.913 64.3811 128.957 64.3928 129.001 64.3962L129.475 64.4346C129.526 64.438 129.568 64.4697 129.585 64.5165C129.604 64.5633 129.593 64.6135 129.56 64.6502L129.241 64.9996C129.166 65.0815 129.136 65.1935 129.161 65.3021L129.271 65.7601C129.283 65.8086 129.266 65.857 129.227 65.8888C129.188 65.9205 129.136 65.9272 129.09 65.9072L128.656 65.715C128.555 65.6698 128.435 65.6782 128.342 65.735L127.935 65.9791C127.913 65.9874 127.89 65.9941 127.866 65.9941Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.614 64.0235L128.582 64.0417L128.653 64.165L128.686 64.1467L128.614 64.0235Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M133.388 66.1561L132.723 65.8603C132.671 65.8369 132.611 65.8402 132.563 65.8703L131.939 66.2447C131.818 66.3183 131.664 66.2213 131.679 66.0809L131.757 65.3639C131.764 65.3087 131.742 65.2535 131.698 65.2168L131.146 64.7471C131.038 64.6552 131.083 64.4797 131.223 64.4513L131.936 64.3042C131.992 64.2925 132.037 64.2557 132.059 64.2039L132.341 63.5386C132.397 63.4083 132.578 63.3966 132.649 63.5203L133.012 64.1454C133.04 64.1938 133.091 64.2256 133.147 64.2306L133.873 64.2891C134.015 64.3008 134.082 64.468 133.986 64.5733L133.496 65.1081C133.457 65.1499 133.444 65.2067 133.456 65.2619L133.623 65.9639C133.66 66.0993 133.52 66.2146 133.388 66.1561Z",
    fill: "url(#paint74_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.885 65.1782C131.867 65.1448 131.841 65.1164 131.813 65.0913L131.451 64.7837C131.414 64.752 131.397 64.7018 131.411 64.6534C131.423 64.6049 131.462 64.5698 131.51 64.5598L131.977 64.4628C132.086 64.4394 132.176 64.3659 132.22 64.2639L132.404 63.8293C132.422 63.7842 132.466 63.7541 132.515 63.7508C132.566 63.7474 132.611 63.7725 132.637 63.816L132.758 64.0249L132.726 64.0433L132.605 63.8344C132.586 63.8026 132.554 63.7859 132.519 63.7876C132.483 63.7892 132.453 63.811 132.438 63.8444L132.253 64.279C132.206 64.3926 132.105 64.4745 131.983 64.4996L131.517 64.5965C131.482 64.6032 131.455 64.6283 131.446 64.6634C131.438 64.6985 131.448 64.7336 131.475 64.757L131.836 65.0645C131.868 65.0913 131.895 65.1247 131.916 65.1598L131.885 65.1782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.003 65.9941C131.979 65.9941 131.956 65.9874 131.935 65.974C131.893 65.9473 131.869 65.9005 131.876 65.852L131.915 65.4943L131.952 65.4977L131.913 65.8554C131.91 65.8905 131.925 65.9239 131.955 65.944C131.986 65.964 132.023 65.964 132.053 65.9456L132.46 65.7016C132.565 65.6381 132.698 65.6297 132.81 65.6799L133.244 65.8721C133.278 65.8871 133.313 65.8821 133.342 65.8587C133.371 65.8353 133.382 65.8019 133.374 65.7668L133.264 65.3088C133.235 65.1901 133.268 65.0648 133.352 64.9745L133.671 64.6252C133.695 64.5984 133.701 64.5633 133.688 64.5299C133.674 64.4965 133.646 64.4747 133.609 64.4714L133.134 64.433C133.085 64.4296 133.038 64.4162 132.994 64.3928L133.011 64.3611C133.05 64.3811 133.094 64.3928 133.137 64.3962L133.612 64.4346C133.663 64.438 133.705 64.4697 133.722 64.5165C133.74 64.5633 133.73 64.6135 133.696 64.6502L133.377 64.9996C133.303 65.0815 133.273 65.1935 133.298 65.3021L133.408 65.7601C133.419 65.8086 133.403 65.857 133.364 65.8888C133.325 65.9205 133.273 65.9272 133.227 65.9072L132.793 65.715C132.692 65.6698 132.572 65.6782 132.479 65.735L132.072 65.9791C132.052 65.9874 132.026 65.9941 132.003 65.9941Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.759 64.0266L132.727 64.0449L132.798 64.1682L132.83 64.1499L132.759 64.0266Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M136.336 62.27C136.331 62.6043 136.007 62.87 135.613 62.865L116.362 62.5959C115.967 62.5909 115.651 62.3151 115.656 61.9808V61.9474C115.661 61.6131 115.986 61.3474 116.379 61.3524L135.63 61.6215C136.025 61.6265 136.341 61.9023 136.336 62.2366V62.27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.347 68.5331C102.345 68.5331 102.342 68.5331 102.34 68.5331L100.067 68.3894C99.9235 68.381 99.7952 68.3024 99.7226 68.1788C99.65 68.0567 99.6449 67.9063 99.7074 67.7793L100.874 65.3841C100.9 65.3323 100.962 65.3105 101.016 65.3356C101.068 65.3607 101.09 65.4242 101.065 65.476L99.8982 67.8712C99.8661 67.9364 99.8695 68.0116 99.9067 68.0735C99.9438 68.1353 100.008 68.1754 100.081 68.1804L102.353 68.3242C102.412 68.3275 102.456 68.3777 102.453 68.4362C102.45 68.4896 102.402 68.5331 102.347 68.5331Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.406 61.5363C112.386 61.5363 112.365 61.533 112.347 61.5229C112.276 61.4912 112.245 61.4076 112.277 61.3374L113.338 59.0609C113.387 58.9572 113.38 58.8219 113.318 58.7249C113.299 58.6965 113.242 58.5728 113.036 58.5728H110.251C110.174 58.5728 110.109 58.4826 110.109 58.4057C110.109 58.3288 110.172 58.2385 110.251 58.2385H113.036C113.335 58.2385 113.483 58.4341 113.556 58.5477C113.671 58.7249 113.684 58.9589 113.595 59.1478L112.534 61.4394C112.51 61.4912 112.46 61.5363 112.406 61.5363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.936 56.5903C41.7199 56.261 41.3518 56.0671 40.955 56.0671H10.2808L9.29297 63.2444L38.6332 63.2059C39.1702 63.2059 39.6565 62.8917 39.876 62.407L42.0205 57.6918C42.1843 57.3324 42.1522 56.9196 41.936 56.5903Z",
    fill: "url(#paint75_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1035 54.1249C17.9819 53.9411 17.7742 53.8291 17.553 53.8291H8.13429C7.50446 53.8291 6.93204 54.1951 6.67538 54.7651L2.4101 64.2138C2.31723 64.4178 2.33581 64.6284 2.45907 64.8156C2.58234 65.0028 2.79172 65.0914 3.01798 65.0914H12.8403C13.2557 65.0914 13.6339 64.8741 13.8011 64.4963L18.1558 54.73C18.2453 54.5294 18.2251 54.3088 18.1035 54.1249Z",
    fill: "url(#paint76_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M13.6512 59.5254C13.6242 61.3674 12.0943 62.8399 10.2335 62.8148C8.37276 62.7881 6.88515 61.2738 6.91047 59.4318C6.93749 57.5899 8.46732 56.1173 10.3281 56.1424C12.1889 56.1675 13.6765 57.6818 13.6512 59.5254Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3286 58.2318C11.3202 58.7967 10.8491 59.4001 10.2783 59.3917C9.70761 59.3834 9.25339 58.7666 9.26183 58.2017C9.27028 57.6367 9.73801 57.2423 10.3087 57.2506C10.8812 57.259 11.3371 57.6668 11.3286 58.2318Z",
    fill: "url(#paint77_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.96694 61.5497L11.4896 61.5848C11.7547 61.5881 11.9928 61.4226 12.0773 61.1719L12.2191 60.754C12.3221 60.4482 12.1667 60.1122 11.8611 59.9969C10.8395 59.6108 9.77745 59.6442 8.68496 59.9868C8.37933 60.0821 8.20541 60.403 8.28477 60.7106L8.3844 61.0933C8.45194 61.3591 8.69171 61.5446 8.96694 61.5497Z",
    fill: "url(#paint78_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9077 62.1478L20.2425 61.852C20.1901 61.8286 20.131 61.8319 20.082 61.862L19.459 62.2364C19.3374 62.31 19.1837 62.213 19.1989 62.0726L19.2766 61.3556C19.2834 61.3004 19.2614 61.2452 19.2175 61.2085L18.6653 60.7388C18.5573 60.6469 18.6029 60.4714 18.743 60.4429L19.4556 60.2959C19.5113 60.2842 19.5569 60.2474 19.5788 60.1956L19.8608 59.5303C19.9166 59.4 20.0972 59.3883 20.1682 59.512L20.5312 60.1371C20.5599 60.1855 20.6106 60.2173 20.6663 60.2223L21.3924 60.2808C21.5342 60.2925 21.6017 60.4597 21.5055 60.565L21.0158 61.0998C20.977 61.1416 20.9635 61.1984 20.9753 61.2536L21.1424 61.9556C21.1779 62.091 21.0378 62.2047 20.9077 62.1478Z",
    fill: "url(#paint79_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.401 61.1699C19.3824 61.1365 19.3571 61.1081 19.3284 61.083L18.967 60.7754C18.9299 60.7437 18.913 60.6935 18.9265 60.6451C18.9383 60.5966 18.9772 60.5615 19.0261 60.5515L19.4922 60.4545C19.6019 60.4311 19.6914 60.3576 19.7353 60.2556L19.9194 59.821C19.9379 59.7759 19.9818 59.7458 20.0308 59.7425C20.0815 59.7391 20.1271 59.7642 20.1524 59.8077L20.274 60.0166L20.2419 60.035L20.1203 59.8261C20.1017 59.7943 20.0696 59.7776 20.0342 59.7793C19.9987 59.7809 19.9683 59.8027 19.9531 59.8361L19.7691 60.2707C19.7218 60.3843 19.6205 60.4662 19.4989 60.4913L19.0329 60.5882C18.9974 60.5949 18.9704 60.62 18.962 60.6551C18.9535 60.6902 18.9636 60.7253 18.9907 60.7487L19.352 61.0562C19.3841 61.083 19.4111 61.1164 19.4314 61.1515L19.401 61.1699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5184 61.9855C19.4948 61.9855 19.4711 61.9789 19.4509 61.9655C19.4087 61.9387 19.385 61.8919 19.3918 61.8435L19.4306 61.4858L19.4678 61.4891L19.4289 61.8468C19.4255 61.8819 19.4407 61.9153 19.4711 61.9354C19.5015 61.9555 19.5387 61.9555 19.5691 61.9371L19.976 61.693C20.0807 61.6295 20.2141 61.6212 20.3255 61.6713L20.7595 61.8635C20.7933 61.8786 20.8287 61.8736 20.8574 61.8502C20.8861 61.8268 20.898 61.7933 20.8895 61.7582L20.7798 61.3003C20.7511 61.1816 20.7831 61.0562 20.8676 60.966L21.1867 60.6166C21.2103 60.5899 21.2171 60.5548 21.2036 60.5214C21.1901 60.4879 21.1614 60.4662 21.1242 60.4629L20.6497 60.4244C20.6008 60.4211 20.5535 60.4077 20.5096 60.3843L20.5265 60.3525C20.5653 60.3726 20.6092 60.3843 20.6531 60.3876L21.1276 60.4261C21.1766 60.4294 21.2205 60.4612 21.2374 60.508C21.2559 60.5548 21.2458 60.6049 21.212 60.6417L20.8929 60.991C20.8186 61.0729 20.7882 61.1849 20.8135 61.2936L20.9233 61.7515C20.9351 61.8 20.9182 61.8485 20.8794 61.8802C20.8405 61.912 20.7882 61.9187 20.7426 61.8986L20.3086 61.7064C20.2073 61.6613 20.0874 61.6696 19.9946 61.7265L19.5876 61.9705C19.5674 61.9789 19.5437 61.9855 19.5184 61.9855Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2705 60.0156L20.2383 60.0339L20.3097 60.1572L20.3419 60.1389L20.2705 60.0156Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7788 62.2013L24.1135 61.9055C24.0612 61.8821 24.0021 61.8854 23.9531 61.9155L23.3301 62.2899C23.2085 62.3634 23.0548 62.2665 23.07 62.1261L23.1477 61.409C23.1544 61.3539 23.1325 61.2987 23.0886 61.2619L22.5364 60.7923C22.4284 60.7003 22.474 60.5248 22.6141 60.4964L23.3267 60.3493C23.3824 60.3376 23.428 60.3009 23.4499 60.249L23.7319 59.5838C23.7877 59.4534 23.9683 59.4417 24.0392 59.5654L24.4023 60.1905C24.431 60.239 24.4816 60.2708 24.5374 60.2758L25.2634 60.3343C25.4053 60.346 25.4728 60.5131 25.3766 60.6184L24.8869 61.1533C24.8481 61.1951 24.8346 61.2519 24.8464 61.3071L25.0135 62.0091C25.0507 62.1445 24.9105 62.2598 24.7788 62.2013Z",
    fill: "url(#paint80_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2721 61.2236C23.2535 61.1902 23.2282 61.1618 23.1995 61.1367L22.8381 60.8292C22.801 60.7974 22.7841 60.7473 22.7976 60.6988C22.8094 60.6503 22.8482 60.6152 22.8972 60.6052L23.3633 60.5082C23.473 60.4848 23.5625 60.4113 23.6064 60.3093L23.7905 59.8748C23.809 59.8296 23.8529 59.7995 23.9019 59.7962C23.9526 59.7929 23.9981 59.8179 24.0235 59.8614L24.1451 60.0703L24.113 60.0887L23.9914 59.8798C23.9728 59.848 23.9407 59.8313 23.9053 59.833C23.8698 59.8346 23.8394 59.8564 23.8242 59.8898L23.6402 60.3244C23.5929 60.438 23.4916 60.5199 23.37 60.545L22.904 60.642C22.8685 60.6486 22.8415 60.6737 22.833 60.7088C22.8246 60.7439 22.8347 60.779 22.8618 60.8024L23.2231 61.11C23.2552 61.1367 23.2822 61.1701 23.3025 61.2052L23.2721 61.2236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3895 62.0393C23.3659 62.0393 23.3422 62.0326 23.322 62.0192C23.2797 61.9925 23.2561 61.9457 23.2629 61.8972L23.3017 61.5395L23.3388 61.5428L23.3 61.9005C23.2966 61.9356 23.3118 61.9691 23.3422 61.9891C23.3726 62.0092 23.4098 62.0092 23.4402 61.9908L23.8471 61.7468C23.9518 61.6832 24.0852 61.6749 24.1966 61.725L24.6306 61.9172C24.6644 61.9323 24.6998 61.9273 24.7285 61.9039C24.7572 61.8805 24.7691 61.847 24.7606 61.8119L24.6509 61.354C24.6221 61.2353 24.6542 61.1099 24.7387 61.0197L25.0578 60.6703C25.0814 60.6436 25.0882 60.6085 25.0747 60.5751C25.0612 60.5416 25.0325 60.5199 24.9953 60.5166L24.5208 60.4781C24.4719 60.4748 24.4246 60.4614 24.3807 60.438L24.3976 60.4062C24.4364 60.4263 24.4803 60.438 24.5242 60.4414L24.9987 60.4798C25.0493 60.4831 25.0916 60.5149 25.1084 60.5617C25.127 60.6085 25.1169 60.6586 25.0831 60.6954L24.764 61.0447C24.6897 61.1266 24.6593 61.2386 24.6846 61.3473L24.7944 61.8053C24.8062 61.8537 24.7893 61.9022 24.7505 61.934C24.7116 61.9657 24.6593 61.9724 24.6137 61.9523L24.1797 61.7601C24.0784 61.715 23.9585 61.7234 23.8657 61.7802L23.4587 62.0242C23.4385 62.0326 23.4131 62.0393 23.3895 62.0393Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1455 60.072L24.1133 60.0903L24.1847 60.2136L24.2169 60.1953L24.1455 60.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.689 62.2565L28.0237 61.9606C27.9714 61.9372 27.9123 61.9406 27.8633 61.9707L27.2402 62.3451C27.1186 62.4186 26.965 62.3217 26.9802 62.1813L27.0578 61.4642C27.0646 61.409 27.0427 61.3539 26.9987 61.3171L26.4466 60.8474C26.3385 60.7555 26.3841 60.58 26.5243 60.5516L27.2368 60.4045C27.2926 60.3928 27.3382 60.356 27.3601 60.3042L27.6421 59.639C27.6978 59.5086 27.8785 59.4969 27.9494 59.6206L28.3124 60.2457C28.3411 60.2942 28.3918 60.3259 28.4475 60.331L29.1736 60.3895C29.3154 60.4012 29.383 60.5683 29.2867 60.6736L28.7971 61.2085C28.7582 61.2503 28.7447 61.3071 28.7565 61.3622L28.9237 62.0643C28.9592 62.1996 28.819 62.3133 28.689 62.2565Z",
    fill: "url(#paint81_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1783 61.2788C27.1597 61.2454 27.1344 61.2169 27.1057 61.1919L26.7444 60.8843C26.7072 60.8526 26.6903 60.8024 26.7038 60.754C26.7157 60.7055 26.7545 60.6704 26.8035 60.6604L27.2695 60.5634C27.3793 60.54 27.4687 60.4665 27.5127 60.3645L27.6967 59.9299C27.7153 59.8848 27.7592 59.8547 27.8081 59.8514C27.8588 59.848 27.9044 59.8731 27.9297 59.9166L28.0513 60.1255L28.0192 60.1439L27.8976 59.9349C27.8791 59.9032 27.847 59.8865 27.8115 59.8881C27.7761 59.8898 27.7457 59.9115 27.7305 59.945L27.5464 60.3796C27.4991 60.4932 27.3978 60.5751 27.2763 60.6002L26.8102 60.6971C26.7748 60.7038 26.7477 60.7289 26.7393 60.764C26.7309 60.7991 26.741 60.8342 26.768 60.8576L27.1294 61.1651C27.1614 61.1919 27.1885 61.2253 27.2087 61.2604L27.1783 61.2788Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2997 62.0944C27.276 62.0944 27.2524 62.0877 27.2321 62.0743C27.1899 62.0476 27.1663 62.0008 27.173 61.9523L27.2119 61.5946L27.249 61.598L27.2102 61.9557C27.2068 61.9908 27.222 62.0242 27.2524 62.0443C27.2828 62.0643 27.3199 62.0643 27.3503 62.0459L27.7573 61.8019C27.8619 61.7384 27.9953 61.73 28.1068 61.7802L28.5407 61.9724C28.5745 61.9874 28.61 61.9824 28.6387 61.959C28.6674 61.9356 28.6792 61.9022 28.6708 61.8671L28.561 61.4091C28.5323 61.2904 28.5644 61.1651 28.6488 61.0748L28.9679 60.7255C28.9916 60.6987 28.9983 60.6636 28.9848 60.6302C28.9713 60.5968 28.9426 60.575 28.9055 60.5717L28.431 60.5333C28.382 60.5299 28.3347 60.5165 28.2908 60.4931L28.3077 60.4597C28.3466 60.4798 28.3905 60.4915 28.4344 60.4948L28.9088 60.5333C28.9578 60.5366 29.0017 60.5684 29.0186 60.6152C29.0372 60.662 29.027 60.7121 28.9933 60.7489L28.6741 61.0982C28.5998 61.1801 28.5694 61.2921 28.5948 61.4007L28.7045 61.8587C28.7164 61.9072 28.6995 61.9557 28.6606 61.9874C28.6218 62.0192 28.5694 62.0259 28.5239 62.0058L28.0899 61.8136C27.9886 61.7685 27.8687 61.7768 27.7758 61.8337L27.3689 62.0777C27.3486 62.0877 27.3233 62.0944 27.2997 62.0944Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0557 60.1277L28.0234 60.146L28.0948 60.2693L28.127 60.251L28.0557 60.1277Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6656 62.3117L32.0003 62.0158C31.9479 61.9924 31.8888 61.9957 31.8398 62.0258L31.2168 62.4002C31.0952 62.4738 30.9415 62.3768 30.9567 62.2364L31.0344 61.5194C31.0412 61.4642 31.0192 61.4091 30.9753 61.3723L30.4232 60.9026C30.3151 60.8107 30.3607 60.6352 30.5008 60.6068L31.2134 60.4597C31.2691 60.448 31.3147 60.4112 31.3367 60.3594L31.6186 59.6942C31.6744 59.5638 31.855 59.5521 31.926 59.6758L32.289 60.3009C32.3177 60.3494 32.3684 60.3811 32.4241 60.3861L33.1502 60.4446C33.292 60.4563 33.3595 60.6235 33.2633 60.7288L32.7736 61.2636C32.7348 61.3054 32.7213 61.3623 32.7331 61.4174L32.9003 62.1194C32.9374 62.2548 32.7956 62.3702 32.6656 62.3117Z",
    fill: "url(#paint82_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1549 61.3337C31.1363 61.3003 31.111 61.2719 31.0823 61.2468L30.7209 60.9393C30.6838 60.9075 30.6669 60.8574 30.6804 60.8089C30.6922 60.7604 30.7311 60.7253 30.78 60.7153L31.2461 60.6183C31.3558 60.5949 31.4453 60.5214 31.4892 60.4194L31.6733 59.9849C31.6918 59.9397 31.7357 59.9096 31.7847 59.9063C31.8354 59.903 31.881 59.928 31.9063 59.9715L32.0279 60.1804L31.9958 60.1988L31.8742 59.9899C31.8556 59.9581 31.8236 59.9414 31.7881 59.9431C31.7526 59.9447 31.7222 59.9665 31.707 59.9999L31.523 60.4345C31.4757 60.5481 31.3744 60.63 31.2528 60.6551L30.7868 60.7521C30.7513 60.7587 30.7243 60.7838 30.7159 60.8189C30.7074 60.854 30.7176 60.8891 30.7446 60.9125L31.1059 61.2201C31.138 61.2468 31.165 61.2802 31.1853 61.3153L31.1549 61.3337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2762 62.1494C31.2526 62.1494 31.2289 62.1427 31.2087 62.1293C31.1665 62.1026 31.1428 62.0558 31.1496 62.0073L31.1884 61.6496L31.2256 61.6529L31.1867 62.0106C31.1834 62.0457 31.1985 62.0792 31.2289 62.0992C31.2593 62.1193 31.2965 62.1193 31.3269 62.1009L31.7338 61.8569C31.8385 61.7933 31.9719 61.785 32.0833 61.8351L32.5173 62.0274C32.5511 62.0424 32.5865 62.0374 32.6152 62.014C32.6439 61.9906 32.6558 61.9572 32.6473 61.9221L32.5376 61.4641C32.5089 61.3454 32.5409 61.22 32.6254 61.1298L32.9445 60.7804C32.9681 60.7537 32.9749 60.7186 32.9614 60.6852C32.9479 60.6517 32.9192 60.63 32.882 60.6267L32.4075 60.5882C32.3586 60.5849 32.3113 60.5715 32.2674 60.5481L32.2843 60.5164C32.3231 60.5364 32.367 60.5481 32.4109 60.5515L32.8854 60.5899C32.9361 60.5932 32.9783 60.625 32.9952 60.6718C33.0137 60.7186 33.0036 60.7687 32.9698 60.8055L32.6507 61.1549C32.5764 61.2368 32.546 61.3487 32.5713 61.4574L32.6811 61.9154C32.6929 61.9638 32.676 62.0123 32.6372 62.0441C32.5984 62.0758 32.546 62.0825 32.5004 62.0625L32.0665 61.8702C31.9651 61.8251 31.8453 61.8335 31.7524 61.8903L31.3454 62.1343C31.3235 62.1427 31.2999 62.1494 31.2762 62.1494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0283 60.1804L31.9961 60.1987L32.0675 60.322L32.0997 60.3037L32.0283 60.1804Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M36.8023 62.3117L36.137 62.0158C36.0846 61.9924 36.0255 61.9957 35.9766 62.0258L35.3535 62.4002C35.2319 62.4738 35.0783 62.3768 35.0935 62.2364L35.1711 61.5194C35.1779 61.4642 35.1559 61.4091 35.112 61.3723L34.5599 60.9026C34.4518 60.8107 34.4974 60.6352 34.6375 60.6068L35.3501 60.4597C35.4058 60.448 35.4514 60.4112 35.4734 60.3594L35.7554 59.6942C35.8111 59.5638 35.9918 59.5521 36.0627 59.6758L36.4257 60.3009C36.4544 60.3494 36.5051 60.3811 36.5608 60.3861L37.2869 60.4446C37.4287 60.4563 37.4963 60.6235 37.4 60.7288L36.9103 61.2636C36.8715 61.3054 36.858 61.3623 36.8698 61.4174L37.037 62.1194C37.0741 62.2548 36.934 62.3702 36.8023 62.3117Z",
    fill: "url(#paint83_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2916 61.3337C35.273 61.3003 35.2477 61.2719 35.219 61.2468L34.8576 60.9393C34.8205 60.9075 34.8036 60.8574 34.8171 60.8089C34.8289 60.7604 34.8678 60.7253 34.9167 60.7153L35.3828 60.6183C35.4925 60.5949 35.582 60.5214 35.6259 60.4194L35.81 59.9849C35.8286 59.9397 35.8725 59.9096 35.9214 59.9063C35.9721 59.903 36.0177 59.928 36.043 59.9715L36.1646 60.1804L36.1325 60.1988L36.0109 59.9899C35.9924 59.9581 35.9603 59.9414 35.9248 59.9431C35.8894 59.9447 35.859 59.9665 35.8438 59.9999L35.6597 60.4345C35.6124 60.5481 35.5111 60.63 35.3895 60.6551L34.9235 60.7521C34.888 60.7587 34.861 60.7838 34.8526 60.8189C34.8441 60.854 34.8543 60.8891 34.8813 60.9125L35.2426 61.2201C35.2747 61.2468 35.3017 61.2802 35.322 61.3153L35.2916 61.3337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4129 62.1494C35.3893 62.1494 35.3657 62.1427 35.3454 62.1293C35.3032 62.1026 35.2795 62.0558 35.2863 62.0073L35.3251 61.6496L35.3623 61.6529L35.3234 62.0106C35.3201 62.0457 35.3353 62.0792 35.3657 62.0992C35.3961 62.1193 35.4332 62.1193 35.4636 62.1009L35.8705 61.8569C35.9752 61.7933 36.1086 61.785 36.2201 61.8351L36.654 62.0274C36.6878 62.0424 36.7233 62.0374 36.752 62.014C36.7807 61.9906 36.7925 61.9572 36.784 61.9221L36.6743 61.4641C36.6456 61.3454 36.6777 61.22 36.7621 61.1298L37.0812 60.7804C37.1049 60.7537 37.1116 60.7186 37.0981 60.6852C37.0846 60.6517 37.0559 60.63 37.0188 60.6267L36.5443 60.5882C36.4953 60.5849 36.448 60.5715 36.4041 60.5481L36.421 60.5164C36.4598 60.5364 36.5037 60.5481 36.5476 60.5515L37.0221 60.5899C37.0728 60.5932 37.115 60.625 37.1319 60.6718C37.1505 60.7186 37.1403 60.7687 37.1066 60.8055L36.7874 61.1549C36.7131 61.2368 36.6827 61.3487 36.7081 61.4574L36.8178 61.9154C36.8296 61.9638 36.8127 62.0123 36.7739 62.0441C36.7351 62.0758 36.6827 62.0825 36.6371 62.0625L36.2032 61.8702C36.1019 61.8251 35.982 61.8335 35.8891 61.8903L35.4822 62.1343C35.4619 62.1427 35.4366 62.1494 35.4129 62.1494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1689 60.1824L36.1367 60.2007L36.2081 60.3239L36.2403 60.3057L36.1689 60.1824Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M39.7501 58.4255C39.745 58.7598 39.4208 59.0256 39.0274 59.0205L19.7762 58.7514C19.3811 58.7464 19.0653 58.4706 19.0704 58.1364V58.1029C19.0754 57.7686 19.3996 57.5029 19.7931 57.5079L39.0443 57.777C39.4394 57.782 39.7551 58.0578 39.7501 58.3921V58.4255Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75677 64.6886C5.75508 64.6886 5.7517 64.6886 5.75001 64.6886L3.47722 64.5449C3.3337 64.5365 3.20537 64.458 3.13276 64.3343C3.06015 64.2123 3.05509 64.0618 3.11756 63.9348L4.28435 61.5396C4.30968 61.4878 4.37216 61.4661 4.42619 61.4911C4.47853 61.5162 4.50049 61.5797 4.47516 61.6315L3.30837 64.0267C3.27629 64.0919 3.27966 64.1671 3.31681 64.229C3.35396 64.2908 3.41812 64.3309 3.49073 64.3359L5.76352 64.4797C5.82262 64.483 5.86652 64.5332 5.86315 64.5917C5.85977 64.6452 5.81249 64.6886 5.75677 64.6886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8199 57.6918C15.7996 57.6918 15.7793 57.6885 15.7608 57.6784C15.6898 57.6467 15.6595 57.5631 15.6915 57.4929L16.7519 55.2164C16.8009 55.1128 16.7942 54.9774 16.7317 54.8804C16.7131 54.852 16.6557 54.7283 16.4497 54.7283H13.6653C13.5876 54.7283 13.5234 54.6381 13.5234 54.5612C13.5234 54.4843 13.5859 54.394 13.6653 54.394H16.4497C16.7486 54.394 16.8972 54.5896 16.9698 54.7033C17.0846 54.8804 17.0981 55.1144 17.0086 55.3033L15.9482 57.5949C15.9246 57.6467 15.8739 57.6918 15.8199 57.6918Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8327 137.713C31.5794 137.546 31.2991 137.429 31.0188 137.387C29.2424 137.128 25.715 139.227 24.1886 137.497C23.324 136.516 24.3878 135.202 24.1109 134.019C23.1839 130.057 18.8291 133.041 16.4888 133.203C14.8627 133.317 13.6892 132.314 12.5984 131.249C10.5316 129.232 8.198 125.217 4.71621 126.574C2.95505 127.261 3.04116 129.426 2.32015 130.858C1.50965 132.473 0.0304775 133.542 -1.80498 133.706C-4.37495 133.935 -8.0256 131.749 -10.3187 133.542C-11.1747 134.213 -12.4817 136.454 -12.171 137.544C-13.5185 137.432 -15.2509 137.089 -16.232 138.293C-16.9175 139.133 -16.8888 140.011 -15.5768 140.048C-14.0875 140.09 -12.6049 140.053 -11.1156 140.071C-2.63912 140.175 5.83572 140.287 14.3122 140.389C18.9389 140.444 23.5638 140.954 28.1871 141.037C29.3555 141.059 32.0893 141.181 32.7158 139.822C33.0619 139.085 32.5554 138.191 31.8327 137.713Z",
    fill: "url(#paint84_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8534 140.275C16.8382 140.275 16.8213 140.27 16.8078 140.262C16.769 140.236 16.7572 140.185 16.7842 140.146C16.9209 139.939 20.1545 135.072 22.2179 133.96C22.2585 133.938 22.3108 133.953 22.3327 133.994C22.3547 134.034 22.3395 134.086 22.299 134.107C20.2727 135.197 16.9598 140.186 16.926 140.236C16.9074 140.262 16.8804 140.275 16.8534 140.275Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7261 136.447C19.6889 136.447 19.6535 136.422 19.645 136.384L18.9206 133.484C18.9088 133.439 18.9375 133.394 18.9831 133.382C19.0287 133.37 19.0743 133.399 19.0861 133.444L19.8105 136.344C19.8223 136.389 19.7936 136.434 19.748 136.446C19.7396 136.446 19.7328 136.447 19.7261 136.447Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.73547 140.407C8.69157 140.407 8.65442 140.372 8.65104 140.329C8.37412 135.409 5.75687 129.586 5.72985 129.528C5.71127 129.486 5.72985 129.436 5.77206 129.417C5.81428 129.399 5.86493 129.417 5.88351 129.459C5.91052 129.518 8.54129 135.368 8.81821 140.318C8.82158 140.365 8.78444 140.404 8.73885 140.407C8.73885 140.407 8.73716 140.407 8.73547 140.407Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.574 139.361C152.006 138.766 150.883 138.746 149.963 138.48C149.44 138.329 148.982 138.097 148.731 137.634C148.259 136.763 148.01 135.346 146.949 134.988C145.828 134.61 144.789 135.528 143.685 135.443C142.105 135.321 142.442 133.683 141.419 132.907C140.487 132.2 138.996 132.374 138.238 133.218C137.709 133.806 137.215 135.643 136.188 135.535C135.71 135.484 135.332 134.771 134.854 134.615C133.709 134.244 132.946 135.202 132.397 136.026C131.994 136.631 131.865 136.95 131.112 137.154C129.706 137.535 127.47 136.967 127.755 139.229C127.755 139.23 127.755 139.234 127.757 139.235C127.828 139.773 128.299 140.17 128.848 140.153C129.988 140.116 131.129 140.063 132.264 140.136C132.91 140.178 133.566 140.166 134.211 140.099C137.183 139.797 140.301 140.27 143.244 140.256C146.235 140.243 149.224 140.215 152.214 140.195C152.413 140.193 152.592 140.076 152.672 139.894C152.749 139.715 152.71 139.504 152.574 139.361Z",
    fill: "url(#paint85_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.667 139.996C134.63 139.996 134.594 139.971 134.586 139.932C134.579 139.902 133.826 136.987 132.946 136.618C132.904 136.599 132.884 136.551 132.9 136.508C132.919 136.466 132.968 136.446 133.012 136.462C133.968 136.864 134.717 139.767 134.749 139.889C134.761 139.934 134.734 139.979 134.689 139.991C134.68 139.994 134.673 139.996 134.667 139.996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2597 133.312L10.9034 132.951C10.8696 132.917 10.8713 132.864 10.9051 132.83C10.9389 132.797 10.9929 132.799 11.0267 132.832L11.0284 132.834L11.3796 133.193L11.3813 133.195C11.4133 133.228 11.4134 133.282 11.3796 133.313C11.3441 133.345 11.2918 133.344 11.2597 133.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1065 132.08L9.77887 131.694C9.74679 131.655 9.75186 131.599 9.79069 131.567C9.82953 131.535 9.88694 131.54 9.91902 131.578L9.92071 131.58L10.2432 131.965L10.2449 131.966C10.277 132.005 10.2719 132.06 10.2331 132.092C10.1943 132.122 10.1385 132.117 10.1065 132.08Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.04961 130.766L8.75242 130.357C8.72203 130.313 8.73047 130.253 8.77437 130.223C8.81828 130.193 8.87906 130.201 8.90946 130.245L8.91115 130.246L9.20327 130.654L9.20496 130.656C9.23535 130.698 9.22522 130.758 9.183 130.788C9.1391 130.818 9.08 130.808 9.04961 130.766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09496 129.38L7.82817 128.951C7.79777 128.904 7.81297 128.841 7.86194 128.812C7.90922 128.784 7.97338 128.797 8.00209 128.846L8.00377 128.847L8.2655 129.273L8.26719 129.275C8.29589 129.322 8.2807 129.384 8.23342 129.412C8.18614 129.441 8.12366 129.426 8.09496 129.38Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.24276 127.93L7.00805 127.483C6.98104 127.432 7.0013 127.366 7.05365 127.34C7.10599 127.313 7.17184 127.333 7.19886 127.385L7.20055 127.387L7.43188 127.831L7.43357 127.833C7.46059 127.885 7.44032 127.948 7.38798 127.973C7.33226 128 7.26978 127.98 7.24276 127.93Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.49512 126.424L6.29081 125.962C6.26548 125.906 6.2925 125.84 6.34822 125.815C6.40563 125.79 6.47148 125.817 6.49681 125.872L6.4985 125.874L6.69775 126.332L6.69944 126.334C6.72308 126.389 6.69775 126.454 6.64203 126.479C6.58462 126.504 6.52045 126.479 6.49512 126.424Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.84881 124.871L5.67489 124.398C5.65293 124.338 5.68502 124.269 5.7458 124.248C5.80659 124.226 5.87582 124.258 5.89777 124.318V124.319L6.06663 124.789V124.791C6.08858 124.851 6.0565 124.916 5.99571 124.938C5.9383 124.961 5.87076 124.93 5.84881 124.871Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.30677 123.28L5.16493 122.797C5.14636 122.732 5.18351 122.663 5.24936 122.645C5.31521 122.626 5.38445 122.663 5.40302 122.728V122.73L5.54148 123.21V123.211C5.56005 123.275 5.52291 123.342 5.45705 123.36C5.39289 123.38 5.32534 123.343 5.30677 123.28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.86836 121.658L4.75691 121.167C4.74172 121.099 4.78562 121.03 4.85485 121.015C4.92408 121 4.99331 121.043 5.00851 121.112V121.114L5.11658 121.602V121.603C5.13177 121.672 5.08787 121.739 5.01864 121.754C4.9511 121.769 4.88356 121.725 4.86836 121.658Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.53203 120.014L4.45098 119.517C4.43916 119.445 4.48813 119.377 4.56242 119.365C4.63503 119.353 4.70426 119.402 4.71608 119.475V119.477V119.479L4.79375 119.972V119.973C4.80557 120.045 4.75492 120.112 4.68231 120.124C4.61139 120.132 4.54385 120.084 4.53203 120.014Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.29147 118.35L4.23913 117.849C4.23068 117.772 4.28641 117.705 4.36408 117.697C4.44175 117.689 4.5093 117.744 4.51774 117.821V117.822V117.824L4.5667 118.32V118.322C4.57346 118.397 4.51774 118.464 4.44175 118.471C4.36746 118.479 4.29991 118.426 4.29147 118.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.15489 116.676L4.13294 116.173C4.12957 116.094 4.19204 116.025 4.2714 116.022C4.35077 116.019 4.42 116.081 4.42337 116.159V116.161V116.163L4.44195 116.661V116.662C4.44532 116.741 4.38285 116.806 4.30349 116.809C4.22412 116.814 4.15827 116.754 4.15489 116.676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.11328 114.998L4.12004 114.493C4.12172 114.411 4.18927 114.344 4.272 114.346C4.35474 114.347 4.42229 114.414 4.4206 114.496V114.498V114.501L4.41047 115.001V115.004C4.40878 115.086 4.34124 115.15 4.2585 115.148C4.17745 115.145 4.11328 115.078 4.11328 114.998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.16826 113.318L4.2054 112.815C4.21216 112.729 4.28645 112.666 4.37257 112.671C4.45869 112.678 4.52285 112.751 4.51779 112.836V112.838V112.841L4.47895 113.34V113.343C4.4722 113.426 4.3979 113.49 4.31347 113.483C4.22567 113.475 4.16319 113.401 4.16826 113.318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.32532 111.643L4.39118 111.143C4.403 111.056 4.48405 110.994 4.57185 111.004C4.65966 111.016 4.72213 111.096 4.712 111.183V111.185V111.188L4.64446 111.683V111.686C4.63264 111.773 4.55159 111.834 4.46378 111.822C4.37598 111.808 4.31519 111.73 4.32532 111.643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.57716 109.981L4.67172 109.487C4.6886 109.396 4.77641 109.338 4.8659 109.355C4.95708 109.371 5.01618 109.458 4.9993 109.547V109.549V109.552L4.90305 110.042V110.045C4.88616 110.134 4.79836 110.192 4.70887 110.174C4.61769 110.155 4.56027 110.07 4.57716 109.981Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9273 108.337L5.05057 107.847C5.07421 107.755 5.16708 107.7 5.25995 107.723C5.35282 107.747 5.40854 107.839 5.3849 107.931V107.932V107.936L5.25995 108.419V108.422C5.23631 108.512 5.14344 108.567 5.05226 108.544C4.95939 108.517 4.90367 108.427 4.9273 108.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.37602 106.714L5.52968 106.232C5.55839 106.141 5.65801 106.09 5.74919 106.119C5.84206 106.147 5.89272 106.246 5.86402 106.336L5.86232 106.339L5.70867 106.814L5.70698 106.817C5.67827 106.908 5.57865 106.958 5.48747 106.929C5.39628 106.901 5.34563 106.804 5.37602 106.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.92219 105.121L6.10624 104.65C6.1417 104.559 6.2447 104.512 6.33589 104.548C6.42707 104.583 6.47435 104.685 6.43889 104.775L6.4372 104.778L6.25484 105.243L6.25315 105.246C6.21769 105.337 6.11469 105.382 6.02351 105.347C5.93232 105.311 5.88673 105.211 5.92219 105.121Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.57145 103.565L6.78083 103.105C6.82136 103.015 6.92942 102.975 7.02061 103.015C7.11179 103.055 7.15231 103.162 7.11179 103.252L7.1101 103.256L6.90072 103.708L6.89903 103.712C6.85682 103.802 6.75044 103.841 6.65926 103.8C6.56976 103.76 6.52924 103.655 6.57145 103.565Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.29842 102.047L7.53313 101.599C7.58041 101.511 7.69186 101.475 7.78135 101.522C7.87084 101.569 7.9063 101.679 7.85902 101.768L7.85733 101.771L7.62263 102.213L7.62094 102.216C7.57366 102.304 7.46221 102.34 7.37272 102.293C7.28661 102.244 7.25115 102.136 7.29842 102.047Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.10811 100.57L8.36646 100.135C8.41881 100.047 8.53363 100.018 8.62312 100.07C8.71262 100.122 8.74132 100.235 8.68898 100.324L8.68729 100.327L8.43063 100.755L8.42894 100.759C8.37659 100.846 8.26177 100.876 8.17397 100.822C8.08447 100.77 8.05577 100.658 8.10811 100.57Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99741 99.1387L9.27939 98.7175C9.3368 98.6306 9.455 98.6072 9.54281 98.664C9.63061 98.7209 9.65425 98.8379 9.59684 98.9248L9.59515 98.9265L9.31485 99.341L9.31316 99.3426C9.25575 99.4296 9.13756 99.4513 9.04975 99.3945C8.96195 99.341 8.93831 99.224 8.99741 99.1387Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.96404 97.7532L10.2663 97.347C10.3305 97.2618 10.4503 97.2434 10.5365 97.3069C10.6226 97.3704 10.6411 97.4891 10.577 97.5743L10.5753 97.576L10.2747 97.9755L10.273 97.9772C10.2089 98.0624 10.089 98.0791 10.0046 98.0173C9.91845 97.9571 9.89987 97.8384 9.96404 97.7532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9927 96.4178L11.3152 96.0267C11.3845 95.9431 11.5077 95.9314 11.5922 95.9983C11.6766 96.0668 11.6884 96.1888 11.6209 96.2724L11.6192 96.2741L11.3 96.6585L11.2984 96.6602C11.2291 96.7421 11.1059 96.7538 11.0231 96.6869C10.937 96.6217 10.9252 96.5014 10.9927 96.4178Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0892 95.1341L12.4303 94.7597C12.5046 94.6794 12.6295 94.6728 12.7123 94.7446C12.795 94.8182 12.8001 94.9419 12.7275 95.0238L12.7258 95.0254L12.3881 95.3948L12.3864 95.3965C12.3121 95.4767 12.1871 95.4834 12.1061 95.4099C12.0234 95.338 12.0166 95.2143 12.0892 95.1341Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2421 93.904L13.6 93.5446C13.6794 93.4661 13.8061 93.4644 13.8871 93.543C13.9665 93.6215 13.9682 93.7469 13.8888 93.8271L13.8871 93.8288L13.5325 94.1831L13.5308 94.1848C13.4531 94.2633 13.3248 94.2633 13.2455 94.1865C13.1644 94.1079 13.1627 93.9809 13.2421 93.904Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4562 92.7255L14.8294 92.3829C14.9121 92.306 15.0422 92.311 15.1198 92.3946C15.1975 92.4765 15.1924 92.6052 15.108 92.682L15.1063 92.6837L14.7348 93.0214L14.7331 93.023C14.6504 93.0982 14.5204 93.0932 14.4444 93.0113C14.3684 92.9294 14.3735 92.8024 14.4562 92.7255Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7214 91.6041L16.1098 91.2781C16.1976 91.2046 16.3293 91.2146 16.4036 91.3015C16.4779 91.3884 16.4678 91.5188 16.38 91.5924L16.3783 91.594L15.9933 91.915L15.9916 91.9166C15.9038 91.9902 15.7721 91.9785 15.6995 91.8915C15.6235 91.8063 15.6336 91.6776 15.7214 91.6041Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0312 90.5375L17.433 90.2283C17.5259 90.1581 17.6576 90.1748 17.7302 90.265C17.8011 90.357 17.7859 90.4873 17.6931 90.5592L17.6914 90.5609L17.2929 90.8651L17.2912 90.8668C17.1983 90.937 17.0666 90.9202 16.9957 90.8283C16.9214 90.7381 16.9383 90.6077 17.0312 90.5375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3875 89.5263L18.8028 89.2338C18.8991 89.1652 19.0342 89.1886 19.1017 89.2839C19.1709 89.3792 19.1473 89.5129 19.0511 89.5797L19.0494 89.5814L18.6374 89.8689L18.6357 89.8706C18.5394 89.9374 18.406 89.9157 18.3385 89.8204C18.2676 89.7252 18.2895 89.5948 18.3875 89.5263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7847 88.5735L20.2119 88.2977C20.3132 88.2325 20.4466 88.261 20.5125 88.3612C20.5783 88.4615 20.5496 88.5936 20.4483 88.6588L20.4466 88.6604L20.0228 88.9312L20.0211 88.9329C19.9198 88.9964 19.7864 88.968 19.7222 88.8694C19.6581 88.7707 19.6851 88.637 19.7847 88.5735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2201 87.6759L21.6592 87.4185C21.7638 87.3567 21.8989 87.3918 21.9614 87.4954C22.0239 87.599 21.9884 87.7328 21.8837 87.7946L21.882 87.7963L21.4481 88.0503L21.4464 88.052C21.3417 88.1122 21.2066 88.0787 21.1458 87.9751C21.0817 87.8698 21.1154 87.7378 21.2201 87.6759Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6896 86.8387L23.1371 86.598C23.2451 86.5395 23.3819 86.5796 23.441 86.6866C23.5001 86.7935 23.4596 86.9289 23.3515 86.9874L23.3498 86.9891L22.9058 87.2248L22.9041 87.2264C22.796 87.2833 22.6609 87.2431 22.6018 87.1362C22.5427 87.0292 22.5816 86.8955 22.6896 86.8387Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1916 86.0597L24.6492 85.8374C24.7624 85.7823 24.8975 85.8291 24.9532 85.9394C25.0089 86.0514 24.9616 86.1851 24.8502 86.2402L24.8485 86.2419L24.396 86.4609L24.3943 86.4625C24.2828 86.516 24.1477 86.4709 24.092 86.3589C24.0329 86.2469 24.0802 86.1132 24.1916 86.0597Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7289 85.3395L26.195 85.1356C26.3115 85.0855 26.4465 85.1373 26.4972 85.2509C26.5479 85.3663 26.4955 85.5 26.3807 85.5501L26.379 85.5518L25.9163 85.7524L25.9147 85.754C25.7981 85.8042 25.6648 85.7524 25.6141 85.637C25.5617 85.5234 25.6141 85.3897 25.7289 85.3395Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2911 84.6809L27.7656 84.4954C27.8855 84.4486 28.0205 84.5071 28.0678 84.6241C28.1151 84.7428 28.056 84.8765 27.9378 84.9233L27.9344 84.925L27.465 85.1072L27.4616 85.1088C27.3417 85.1556 27.2083 85.0971 27.1611 84.9785C27.1138 84.8598 27.1712 84.7261 27.2911 84.6809Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8792 84.084L29.3587 83.9169C29.4803 83.8751 29.6137 83.9386 29.6559 84.059C29.6981 84.1793 29.6339 84.3114 29.5124 84.3531H29.5107L29.0345 84.5169L29.0328 84.5186C28.9112 84.5604 28.7778 84.4969 28.7356 84.3765C28.6934 84.2579 28.7576 84.1258 28.8792 84.084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4878 83.5476L30.9741 83.3989C31.0974 83.3604 31.2291 83.429 31.2679 83.551C31.3067 83.673 31.2375 83.8034 31.1142 83.8418H31.1126L30.6313 83.9889H30.6296C30.5064 84.0273 30.3747 83.9588 30.3358 83.8351C30.2953 83.7165 30.3645 83.5861 30.4878 83.5476Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1141 83.0696L32.6054 82.9375C32.7304 82.9041 32.8604 82.9776 32.8942 83.1013C32.9279 83.225 32.8536 83.3537 32.7287 83.3871H32.727L32.2407 83.5175H32.239C32.1141 83.5509 31.984 83.4774 31.9503 83.3537C31.9148 83.2317 31.9891 83.103 32.1141 83.0696Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7553 82.6467L34.25 82.5313C34.3767 82.5012 34.505 82.5798 34.5354 82.7052C34.5658 82.8305 34.4864 82.9575 34.3598 82.9876H34.3581L33.8667 83.1013H33.865C33.7384 83.1314 33.6101 83.0528 33.5814 82.9275C33.5493 82.8021 33.6286 82.6767 33.7553 82.6467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4079 82.2789L35.906 82.1786C36.0344 82.1535 36.1593 82.2354 36.1863 82.3624C36.2117 82.4895 36.1289 82.6132 36.0006 82.6399H35.9989L35.5042 82.7385H35.5025C35.3741 82.7636 35.2492 82.6817 35.2239 82.5547C35.1968 82.4276 35.2796 82.3039 35.4079 82.2789Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0781 81.9646L37.5796 81.881C37.7097 81.8593 37.8329 81.9462 37.8549 82.0749C37.8768 82.2036 37.789 82.3256 37.659 82.3474H37.6573L37.1592 82.4293H37.1575C37.0275 82.451 36.9042 82.3641 36.8823 82.2354C36.8603 82.1083 36.9481 81.9863 37.0781 81.9646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7536 81.7022L39.2568 81.6337C39.3885 81.6153 39.5084 81.7072 39.5269 81.8359C39.5455 81.9663 39.4526 82.085 39.3226 82.1034H39.3209L38.8211 82.1702H38.8194C38.6877 82.1886 38.5679 82.0967 38.5493 81.968C38.5307 81.8393 38.6219 81.7206 38.7536 81.7022Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4317 81.4901L40.9383 81.4366C41.07 81.4232 41.1899 81.5168 41.2034 81.6472C41.2169 81.7776 41.1224 81.8962 40.9907 81.9096H40.989L40.4875 81.9631H40.4858C40.3541 81.9765 40.2359 81.8829 40.2207 81.7525C40.2038 81.6221 40.3 81.5051 40.4317 81.4901Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1164 81.3279L42.623 81.2878C42.7564 81.2778 42.8729 81.3764 42.883 81.5068C42.8932 81.6388 42.7936 81.7541 42.6618 81.7642H42.6602L42.157 81.8026H42.1553C42.0219 81.8127 41.9071 81.714 41.8952 81.5837C41.8851 81.4533 41.9847 81.338 42.1164 81.3279Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8129 81.2124L44.3211 81.1873C44.4545 81.1806 44.5694 81.2826 44.5761 81.4146C44.5829 81.5467 44.4799 81.6603 44.3465 81.667H44.3448L43.8416 81.6921H43.8399C43.7065 81.6988 43.5917 81.5968 43.5866 81.4648C43.5765 81.3311 43.6795 81.2191 43.8129 81.2124Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5045 81.1424L46.0128 81.1307C46.1479 81.1273 46.2593 81.2326 46.2627 81.3664C46.2661 81.5001 46.1597 81.6104 46.0246 81.6137H46.0229L45.5197 81.6254H45.5181C45.383 81.6288 45.2715 81.5235 45.2698 81.3898C45.2631 81.256 45.3695 81.1457 45.5045 81.1424Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2002 81.1172H47.7085C47.8435 81.1172 47.9533 81.2258 47.9533 81.3596C47.9533 81.4933 47.8435 81.6019 47.7085 81.6019H47.7068L47.2019 81.6002H47.2002C47.0651 81.6002 46.9554 81.4916 46.9571 81.3579C46.9554 81.2242 47.0651 81.1172 47.2002 81.1172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8945 81.134L49.4028 81.1473C49.5379 81.1507 49.6459 81.2627 49.6425 81.3964C49.6392 81.5301 49.526 81.6371 49.391 81.6337H49.3893L48.8844 81.6204H48.8827C48.7476 81.617 48.6412 81.505 48.6446 81.3713C48.6463 81.2359 48.7594 81.1289 48.8945 81.134Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5851 81.1907L51.0933 81.2158C51.2301 81.2225 51.3348 81.3378 51.3281 81.4715C51.3213 81.6069 51.2048 81.7106 51.0697 81.7039H51.068L50.5631 81.6788H50.5615C50.4264 81.6721 50.3217 81.5568 50.3284 81.4231C50.3335 81.2877 50.45 81.184 50.5851 81.1907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2797 81.2861L52.788 81.3229C52.9248 81.3329 53.0278 81.4499 53.0176 81.5853C53.0075 81.7207 52.8893 81.8226 52.7525 81.8126H52.7508L52.246 81.7758H52.2443C52.1075 81.7658 52.0062 81.6488 52.0163 81.5134C52.0248 81.378 52.143 81.2761 52.2797 81.2861Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9689 81.4214L54.4755 81.4682C54.6123 81.4816 54.7119 81.6002 54.7001 81.7356C54.6882 81.871 54.5667 81.9696 54.4299 81.9579H54.4282L53.925 81.9094H53.9233C53.7866 81.8961 53.6869 81.7757 53.7004 81.642C53.7106 81.5066 53.8322 81.408 53.9689 81.4214Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.656 81.5902L56.1609 81.6487C56.2977 81.6637 56.3956 81.7874 56.3804 81.9228C56.3652 82.0582 56.2403 82.1551 56.1035 82.1401H56.1018L55.6003 82.0816H55.5986C55.4619 82.0665 55.3639 81.9428 55.3808 81.8074C55.396 81.6721 55.5193 81.5751 55.656 81.5902Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3368 81.796L57.8399 81.8645C57.9767 81.8829 58.073 82.0082 58.0544 82.1436C58.0358 82.279 57.9092 82.3743 57.7724 82.3559H57.7707L57.2692 82.2874H57.2675C57.1307 82.269 57.0345 82.1436 57.0531 82.0083C57.0733 81.8729 57.2 81.7776 57.3368 81.796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0129 82.0349L59.5144 82.1134C59.6511 82.1352 59.7457 82.2622 59.7238 82.3976C59.7018 82.533 59.5735 82.6266 59.4367 82.6048H59.435L58.9369 82.5263H58.9352C58.7984 82.5046 58.7039 82.3775 58.7258 82.2421C58.7478 82.1067 58.8761 82.0131 59.0129 82.0349Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6826 82.3057L61.1824 82.3926C61.3192 82.416 61.412 82.5464 61.3867 82.6818C61.3631 82.8172 61.2313 82.9091 61.0946 82.884H61.0929L60.5965 82.7971H60.5948C60.458 82.7737 60.3668 82.6433 60.3904 82.5079C60.4141 82.3726 60.5441 82.2823 60.6826 82.3057Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3523 82.6066L62.8504 82.7018C62.9872 82.7286 63.0783 82.8606 63.0513 82.996C63.0243 83.1314 62.8909 83.2217 62.7541 83.1949H62.7524L62.2577 83.0996H62.256C62.1192 83.0729 62.0297 82.9409 62.0551 82.8055C62.0821 82.6684 62.2138 82.5798 62.3523 82.6066Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0069 82.9341L64.5033 83.0377C64.6401 83.0661 64.7296 83.1999 64.6992 83.3369C64.6705 83.474 64.5354 83.5609 64.397 83.5308H64.3953L63.9022 83.4272H63.9005C63.7638 83.3988 63.676 83.265 63.7047 83.128C63.7351 82.9926 63.8701 82.9057 64.0069 82.9341Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6611 83.2884L66.1558 83.3987C66.2943 83.4288 66.3804 83.5658 66.3483 83.7012C66.3179 83.8383 66.1795 83.9235 66.0427 83.8918H66.041L65.5479 83.7798H65.5463C65.4095 83.748 65.3234 83.6126 65.3538 83.4773C65.3858 83.3419 65.5226 83.2566 65.6611 83.2884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3097 83.668L67.8027 83.7867C67.9412 83.8201 68.0256 83.9572 67.9919 84.0926C67.9581 84.2296 67.8196 84.3132 67.6829 84.2798H67.6812L67.1898 84.1611H67.1881C67.0513 84.1277 66.9669 83.9906 66.999 83.8552C67.0345 83.7181 67.1712 83.6346 67.3097 83.668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9529 84.0689L69.4442 84.1926C69.5827 84.2277 69.6654 84.3664 69.63 84.5035C69.5945 84.6405 69.4544 84.7225 69.3159 84.6874H69.3142L68.8245 84.5637H68.8229C68.6844 84.5286 68.6016 84.3898 68.6371 84.2528C68.6743 84.1157 68.8144 84.0338 68.9529 84.0689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5899 84.4903L71.0795 84.6206C71.218 84.6574 71.2991 84.7978 71.2619 84.9349C71.2248 85.0719 71.0829 85.1521 70.9445 85.1154H70.9428L70.4548 84.985H70.4531C70.3146 84.9482 70.2336 84.8078 70.2707 84.6708C70.3096 84.5354 70.4514 84.4535 70.5899 84.4903Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2213 84.9332L72.7093 85.0686C72.8477 85.107 72.9271 85.2491 72.8883 85.3862C72.8494 85.5232 72.7059 85.6018 72.5674 85.5633H72.5658L72.0795 85.4279C71.941 85.3895 71.8616 85.2474 71.9005 85.1104C71.9393 84.9733 72.0828 84.8931 72.2213 84.9332Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8487 85.3928L74.335 85.5349C74.4718 85.575 74.5512 85.7171 74.5106 85.8541C74.4701 85.9895 74.3249 86.0681 74.1881 86.028L73.7035 85.8876C73.565 85.8474 73.4857 85.7054 73.5262 85.5683C73.5667 85.4312 73.7103 85.3527 73.8487 85.3928Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4678 85.869L75.9524 86.0145C76.0891 86.0562 76.1668 86.1983 76.1246 86.3337C76.0824 86.4691 75.9389 86.5443 75.8021 86.5042L75.3175 86.3588C75.1807 86.3187 75.103 86.1749 75.1436 86.0395C75.1841 85.9058 75.3293 85.8289 75.4678 85.869Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.082 86.3607L77.5666 86.5111C77.7017 86.5529 77.7776 86.6966 77.7354 86.8303C77.6932 86.9641 77.548 87.0393 77.4112 86.9975L76.9283 86.8487C76.7915 86.8069 76.7155 86.6632 76.7578 86.5295C76.8017 86.3941 76.9452 86.3189 77.082 86.3607Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6915 86.8654L79.1744 87.0191C79.3095 87.0626 79.3838 87.2047 79.3399 87.3384C79.296 87.4721 79.1508 87.5456 79.0157 87.5022L78.5345 87.3501C78.3994 87.3066 78.3251 87.1645 78.3673 87.0308C78.4095 86.8971 78.5547 86.8219 78.6915 86.8654Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2979 87.3818L80.7792 87.5389C80.9143 87.5824 80.9869 87.7261 80.943 87.8582C80.8991 87.9919 80.7538 88.0637 80.6188 88.0203L80.1375 87.8648C80.0024 87.8214 79.9298 87.6776 79.9737 87.5456C80.0176 87.4102 80.1629 87.3383 80.2979 87.3818Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9056 87.9083L82.3869 88.0671C82.5203 88.1122 82.5929 88.2543 82.5473 88.3863C82.5017 88.5183 82.3582 88.5902 82.2248 88.5451L81.7452 88.3863C81.6118 88.3428 81.5392 88.1991 81.5831 88.0671C81.627 87.935 81.7722 87.8631 81.9056 87.9083Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5091 88.4415L83.9886 88.6036C84.122 88.6487 84.1929 88.7908 84.1473 88.9229C84.1017 89.0549 83.9582 89.1251 83.8248 89.08L83.3453 88.9195C83.2119 88.8744 83.141 88.7323 83.1849 88.6003C83.2304 88.4682 83.3757 88.3963 83.5091 88.4415Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1069 88.9832L85.5864 89.147C85.7182 89.1921 85.7891 89.3342 85.7435 89.4662C85.6979 89.5966 85.5544 89.6668 85.421 89.6217L84.9414 89.4595C84.808 89.4144 84.7388 89.2723 84.7827 89.1403C84.8266 89.0082 84.9752 88.938 85.1069 88.9832Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7035 89.5279L87.1831 89.6917C87.3148 89.7368 87.384 89.8789 87.3384 90.0092C87.2928 90.1396 87.1493 90.2081 87.0176 90.163L86.5381 89.9992C86.4063 89.9541 86.3354 89.812 86.381 89.6816C86.4283 89.5529 86.5718 89.4827 86.7035 89.5279Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2997 90.0778L88.7775 90.2433C88.9092 90.2884 88.9785 90.4305 88.9329 90.5609C88.8873 90.6913 88.7438 90.7598 88.6121 90.7147L88.1342 90.5492C88.0025 90.5041 87.9333 90.362 87.9789 90.2316C88.0245 90.1012 88.168 90.0327 88.2997 90.0778Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8919 90.6296L90.3698 90.7951C90.4998 90.8402 90.569 90.9823 90.5235 91.111C90.4779 91.2397 90.3343 91.3082 90.2043 91.2631L89.7265 91.0976C89.5947 91.0525 89.5272 90.9104 89.5728 90.7817C89.6184 90.653 89.7619 90.5845 89.8919 90.6296Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4916 91.1828L91.9695 91.3482C92.0995 91.3934 92.1688 91.5338 92.1232 91.6641C92.0776 91.7928 91.9357 91.8614 91.8057 91.8162L91.3279 91.6508C91.1978 91.6056 91.1286 91.4652 91.1742 91.3349C91.2198 91.2045 91.3599 91.1376 91.4916 91.1828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0815 91.7327L93.561 91.8982C93.6911 91.9433 93.7603 92.0837 93.7147 92.2124C93.6691 92.3411 93.5273 92.4097 93.3972 92.3645L92.9177 92.1991C92.7877 92.1539 92.7184 92.0135 92.764 91.8848C92.8079 91.7561 92.9498 91.6893 93.0815 91.7327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6774 92.2827L95.157 92.4465C95.287 92.4899 95.3562 92.6303 95.3107 92.759C95.2668 92.8878 95.1249 92.9563 94.9949 92.9112L94.5154 92.7474C94.3853 92.7039 94.3161 92.5635 94.3617 92.4348C94.4056 92.3061 94.5474 92.2376 94.6774 92.2827Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2734 92.8274L96.753 92.9895C96.883 93.033 96.9505 93.1717 96.9066 93.3004C96.8627 93.4291 96.7226 93.4976 96.5926 93.4525L96.113 93.2904C95.983 93.2469 95.9138 93.1065 95.9593 92.9795C96.0016 92.8508 96.1434 92.7822 96.2734 92.8274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8741 93.3656L98.3537 93.5261C98.482 93.5695 98.5529 93.7066 98.509 93.8353C98.4651 93.9623 98.325 94.0325 98.1966 93.989L97.7154 93.8286C97.5854 93.7851 97.5162 93.6464 97.5601 93.5194C97.604 93.3907 97.7441 93.3221 97.8741 93.3656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4713 93.8972L99.9526 94.056C100.081 94.0978 100.152 94.2349 100.11 94.3636C100.067 94.4906 99.9272 94.5608 99.7989 94.519L99.3177 94.3619C99.1893 94.3201 99.1184 94.1814 99.1606 94.0543C99.2029 93.924 99.3413 93.8554 99.4713 93.8972Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.073 94.4204L101.554 94.5758C101.682 94.6176 101.753 94.753 101.711 94.8817C101.669 95.0087 101.532 95.0789 101.402 95.0371L100.919 94.8817C100.791 94.8399 100.72 94.7029 100.762 94.5758C100.806 94.4488 100.943 94.3803 101.073 94.4204Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.682 94.9334L103.165 95.0855C103.293 95.1256 103.364 95.261 103.324 95.3881C103.283 95.5151 103.146 95.5853 103.018 95.5452L102.533 95.3931C102.405 95.353 102.334 95.2176 102.375 95.0889C102.415 94.9635 102.554 94.8933 102.682 94.9334Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.29 95.4348L104.775 95.5836C104.903 95.622 104.976 95.7574 104.937 95.8844C104.898 96.0115 104.761 96.0833 104.633 96.0432L104.148 95.8961C104.02 95.8577 103.947 95.7223 103.988 95.5953C104.025 95.4666 104.162 95.3964 104.29 95.4348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.903 95.923L106.388 96.0667C106.516 96.1035 106.589 96.2372 106.552 96.3642C106.515 96.4912 106.378 96.5631 106.25 96.5264L105.763 96.3826C105.635 96.3442 105.562 96.2104 105.6 96.0834C105.637 95.9564 105.773 95.8845 105.903 95.923Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.525 96.3959L108.011 96.5347C108.14 96.5714 108.214 96.7035 108.177 96.8305C108.14 96.9576 108.006 97.0311 107.878 96.9943L107.39 96.8556C107.262 96.8188 107.187 96.6868 107.224 96.5598C107.262 96.4327 107.397 96.3592 107.525 96.3959Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.146 96.8521L109.634 96.9858C109.762 97.0209 109.838 97.1513 109.803 97.2784C109.767 97.4054 109.635 97.4806 109.507 97.4455L109.017 97.3118C108.889 97.2767 108.813 97.1463 108.849 97.0193C108.884 96.8922 109.016 96.817 109.146 96.8521Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.769 97.292L111.259 97.419H111.26C111.389 97.4524 111.465 97.5828 111.431 97.7082C111.397 97.8352 111.265 97.9104 111.139 97.877L110.647 97.7499C110.519 97.7165 110.443 97.5861 110.477 97.4591C110.509 97.3337 110.641 97.2569 110.769 97.292Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.403 97.7098L112.893 97.8318H112.894C113.023 97.8636 113.101 97.9923 113.068 98.1176C113.036 98.2447 112.906 98.3216 112.78 98.2898L112.287 98.1678C112.158 98.136 112.081 98.0073 112.113 97.8803C112.143 97.7549 112.273 97.678 112.403 97.7098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.04 98.1058L114.531 98.2211H114.533C114.661 98.2512 114.74 98.3782 114.71 98.5036C114.68 98.6306 114.551 98.7092 114.425 98.6791L113.93 98.5638C113.802 98.5337 113.722 98.4066 113.753 98.2796C113.781 98.1543 113.91 98.0757 114.04 98.1058Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.68 98.4803L116.173 98.5872H116.175C116.303 98.6156 116.384 98.741 116.355 98.8664C116.327 98.9934 116.202 99.0736 116.074 99.0452L115.577 98.9382C115.449 98.9098 115.368 98.7845 115.396 98.6591C115.425 98.5337 115.55 98.4518 115.68 98.4803Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.326 98.8298L117.82 98.9301H117.822C117.95 98.9551 118.033 99.0788 118.006 99.2058C117.981 99.3329 117.856 99.4148 117.727 99.388L117.229 99.2877C117.101 99.2627 117.018 99.139 117.044 99.012C117.072 98.8849 117.197 98.803 117.326 98.8298Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.982 99.1521L119.479 99.2441H119.48C119.609 99.2675 119.693 99.3895 119.67 99.5165C119.646 99.6436 119.523 99.7271 119.396 99.7037L118.896 99.6118C118.768 99.5884 118.683 99.4664 118.707 99.3393C118.729 99.2106 118.852 99.1271 118.982 99.1521Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.636 99.4448L121.135 99.525H121.136C121.265 99.5451 121.351 99.6655 121.33 99.7908C121.31 99.9178 121.19 100.003 121.062 99.983L120.56 99.9028C120.432 99.8827 120.346 99.7624 120.366 99.637C120.386 99.51 120.508 99.4248 120.635 99.4448H120.636Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.298 99.6954L122.798 99.7606H122.8C122.928 99.7773 123.018 99.8943 123.001 100.02C122.984 100.147 122.867 100.235 122.739 100.219L122.234 100.153C122.106 100.137 122.016 100.02 122.033 99.8943C122.05 99.7673 122.168 99.6787 122.295 99.6954H122.298Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.969 99.8943L124.47 99.9428H124.473C124.602 99.9545 124.695 100.068 124.683 100.195C124.671 100.322 124.556 100.414 124.428 100.402L123.921 100.354C123.793 100.342 123.7 100.229 123.712 100.102C123.724 99.9745 123.839 99.8826 123.967 99.8943H123.969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.641 100.036L126.145 100.067H126.148C126.275 100.075 126.373 100.182 126.364 100.307C126.356 100.433 126.248 100.53 126.121 100.521L125.613 100.493C125.484 100.486 125.388 100.377 125.395 100.25C125.402 100.123 125.511 100.028 125.64 100.035L125.641 100.036Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.318 100.11L127.822 100.117H127.825C127.952 100.118 128.051 100.22 128.05 100.346C128.048 100.471 127.945 100.57 127.818 100.568L127.308 100.561C127.182 100.56 127.08 100.458 127.082 100.332C127.084 100.207 127.187 100.107 127.313 100.108L127.318 100.11Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.995 100.105L129.498 100.087H129.501C129.626 100.082 129.731 100.179 129.734 100.301C129.739 100.424 129.643 100.528 129.518 100.531L129.008 100.551C128.883 100.556 128.779 100.459 128.774 100.337C128.769 100.214 128.867 100.11 128.99 100.105H128.995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.67 100.011L131.17 99.963H131.175C131.298 99.9513 131.406 100.04 131.418 100.162C131.43 100.284 131.341 100.391 131.219 100.403L130.711 100.453C130.587 100.464 130.478 100.376 130.466 100.254C130.454 100.132 130.544 100.023 130.667 100.011H130.67Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.331 99.814L132.826 99.7338H132.831C132.951 99.7137 133.064 99.794 133.084 99.9126C133.105 100.031 133.023 100.143 132.904 100.163L132.399 100.247C132.279 100.267 132.164 100.187 132.144 100.068C132.123 99.9494 132.205 99.8357 132.324 99.8157L132.331 99.814Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.973 99.5016L134.459 99.383L134.464 99.3813C134.581 99.3529 134.699 99.4231 134.727 99.5401C134.756 99.6554 134.685 99.7724 134.569 99.8008L134.072 99.9229C133.956 99.9513 133.838 99.8811 133.807 99.7657C133.778 99.6504 133.849 99.5334 133.966 99.5033L133.973 99.5016Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.583 99.0621L136.058 98.9033L136.063 98.9016C136.176 98.8648 136.298 98.9233 136.335 99.0353C136.372 99.1473 136.313 99.2676 136.2 99.3044L135.715 99.4682C135.602 99.5067 135.48 99.4465 135.441 99.3345C135.403 99.2225 135.463 99.1022 135.577 99.0637L135.583 99.0621Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.144 98.4837L137.602 98.2815L137.607 98.2781C137.713 98.2313 137.84 98.2781 137.887 98.3851C137.934 98.4904 137.887 98.6158 137.78 98.6626L137.313 98.8715C137.205 98.92 137.08 98.8715 137.031 98.7662C136.982 98.6592 137.031 98.5355 137.137 98.4871L137.144 98.4837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.784 71.0701L137.326 70.8679L137.321 70.8662C137.247 70.8344 137.215 70.7475 137.247 70.6757C137.279 70.6021 137.365 70.5704 137.439 70.6021L137.907 70.806C137.981 70.8378 138.015 70.9247 137.983 70.9983C137.951 71.0718 137.863 71.1052 137.789 71.0735L137.784 71.0701Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.231 70.46L135.753 70.3113L135.748 70.3096C135.674 70.2862 135.631 70.2076 135.655 70.1341C135.679 70.0605 135.758 70.0188 135.832 70.0422L136.32 70.1909C136.396 70.2143 136.438 70.2929 136.415 70.3681C136.391 70.4433 136.312 70.4851 136.236 70.4617L136.231 70.46Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.618 70.0322L134.125 69.942L134.12 69.9403C134.046 69.9269 133.997 69.8551 134.01 69.7815C134.024 69.708 134.094 69.6595 134.169 69.6729L134.672 69.7615C134.748 69.7748 134.797 69.8467 134.783 69.9202C134.77 69.9955 134.697 70.0439 134.623 70.0306L134.618 70.0322Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.964 69.8015L132.462 69.7731H132.457C132.385 69.7697 132.329 69.7062 132.332 69.6343C132.336 69.5625 132.398 69.5073 132.471 69.5106L132.982 69.5374C133.057 69.5407 133.112 69.6042 133.109 69.6761C133.106 69.7497 133.041 69.8048 132.969 69.8015H132.964Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.29 69.7782L130.791 69.81H130.786C130.715 69.815 130.654 69.7615 130.649 69.6913C130.644 69.6211 130.698 69.5609 130.767 69.5559L131.277 69.5208C131.348 69.5158 131.41 69.5693 131.415 69.6395C131.42 69.7097 131.366 69.7716 131.295 69.7766L131.29 69.7782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.626 69.9554L129.133 70.0456H129.13C129.062 70.0573 128.998 70.0139 128.986 69.9487C128.974 69.8818 129.018 69.82 129.084 69.8066L129.586 69.7113C129.653 69.698 129.719 69.7431 129.731 69.8099C129.744 69.8768 129.699 69.942 129.631 69.9537L129.626 69.9554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.998 70.323L127.516 70.4684L127.513 70.4701C127.451 70.4885 127.385 70.4534 127.364 70.3915C127.346 70.3297 127.38 70.2645 127.442 70.2445L127.93 70.094C127.993 70.074 128.06 70.1091 128.08 70.1726C128.101 70.2344 128.065 70.3013 128.001 70.3213L127.998 70.323Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.417 70.8697L125.956 71.0669L125.953 71.0686C125.895 71.0937 125.828 71.0669 125.802 71.0101C125.777 70.9533 125.804 70.8864 125.862 70.8613L126.329 70.6591C126.388 70.634 126.456 70.6608 126.481 70.7176C126.507 70.7761 126.48 70.843 126.422 70.868L126.417 70.8697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.901 71.5849L124.463 71.8306L124.46 71.8323C124.408 71.8623 124.34 71.844 124.312 71.7921C124.281 71.7403 124.3 71.6751 124.352 71.6451L124.794 71.3927C124.847 71.3626 124.916 71.381 124.946 71.4328C124.977 71.4846 124.958 71.5531 124.906 71.5832L124.901 71.5849Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.477 72.4575L123.069 72.7483L123.065 72.75C123.018 72.7834 122.952 72.7734 122.918 72.7266C122.885 72.6798 122.895 72.6163 122.942 72.5828L123.354 72.2853C123.401 72.2519 123.467 72.2619 123.503 72.3087C123.536 72.3555 123.526 72.4207 123.479 72.4558L123.477 72.4575Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.156 73.4803L121.783 73.8146L121.781 73.8163C121.74 73.853 121.676 73.8497 121.639 73.8096C121.602 73.7695 121.605 73.7059 121.646 73.6692L122.022 73.3282C122.063 73.2914 122.129 73.2931 122.166 73.3349C122.203 73.3767 122.201 73.4402 122.159 73.477L122.156 73.4803Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.959 74.6422L120.626 75.0166L120.624 75.0183C120.589 75.0567 120.53 75.0617 120.489 75.0266C120.451 74.9915 120.445 74.933 120.481 74.8929L120.815 74.5118C120.851 74.4717 120.911 74.4684 120.952 74.5018C120.993 74.5369 120.996 74.5971 120.962 74.6372L120.959 74.6422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.906 75.9323L119.621 76.3435L119.619 76.3468C119.591 76.387 119.535 76.3987 119.493 76.3702C119.452 76.3418 119.44 76.2867 119.469 76.2449L119.756 75.827C119.785 75.7852 119.842 75.7752 119.884 75.8019C119.927 75.8304 119.937 75.8872 119.91 75.929L119.906 75.9323Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.013 77.3398L118.782 77.7827L118.78 77.7861C118.759 77.8279 118.706 77.8446 118.664 77.8229C118.622 77.8011 118.605 77.7493 118.627 77.7075L118.858 77.2579C118.88 77.2144 118.932 77.1977 118.976 77.2195C119.02 77.2412 119.037 77.293 119.015 77.3365L119.013 77.3398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.361 94.6059L116.148 94.6577L117.623 93.2837C117.989 92.9428 118.548 92.8876 118.972 93.1584C119.22 93.3172 119.488 93.5328 119.721 93.8186C119.721 93.8186 122.349 92.8675 123.622 90.7415C124.019 91.3248 124.483 92.1187 124.885 93.1066C123.742 93.7701 122.263 94.2916 120.361 94.6059Z",
    fill: "url(#paint86_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.882 124.341C116.003 124.436 117.95 124.593 119.484 124.66C120.405 124.7 120.937 124.612 121.243 124.49C121.243 124.523 121.241 124.557 121.24 124.587C121.233 124.747 121.101 124.874 120.937 124.884C118.038 125.045 115.732 124.939 114.911 124.891C114.74 124.881 114.641 124.699 114.727 124.555C114.774 124.48 114.826 124.41 114.882 124.341Z",
    fill: "url(#paint87_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.488 124.66C117.953 124.593 116.008 124.438 114.887 124.341C115.989 123.002 119.488 122.1 119.488 122.1H120.476C121.156 123.069 121.254 123.993 121.246 124.49C120.942 124.61 120.41 124.7 119.488 124.66Z",
    fill: "url(#paint88_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.641 120.502L120.548 122.314C120.538 122.509 120.389 122.675 120.192 122.703C119.994 122.731 119.729 122.735 119.449 122.643C119.276 122.586 119.148 122.442 119.116 122.267L118.797 120.503H120.641V120.502Z",
    fill: "url(#paint89_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.114 125.899C132.6 125.82 132.82 125.529 132.912 125.218C132.912 125.222 132.914 125.223 132.914 125.227C132.985 125.554 132.82 125.895 132.489 126.057C132.088 126.253 131.649 126.286 131.31 126.27C130.945 126.253 130.609 126.077 130.425 125.8L130.422 125.795C130.79 126.004 131.303 126.029 132.114 125.899Z",
    fill: "url(#paint90_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.822 121.06H130.637C131.878 121.031 132.658 124.048 132.913 125.217C132.82 125.528 132.601 125.818 132.115 125.897C131.304 126.027 130.789 126.002 130.423 125.793C129.752 124.775 129.42 123.286 129.259 122.417C129.077 121.429 129.822 121.06 129.822 121.06Z",
    fill: "url(#paint91_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.53 119.378L130.983 121.16C131.039 121.379 130.932 121.605 130.728 121.708C130.475 121.837 130.118 121.973 129.791 121.932C129.637 121.914 129.509 121.807 129.458 121.663L128.793 119.788L130.53 119.378Z",
    fill: "url(#paint92_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.609 95.9096C114.609 95.9096 118.653 120.936 118.588 121.075C118.588 121.075 119.705 121.578 120.923 121.138C120.923 121.138 120.556 107.76 119.7 102.63C119.7 102.63 126.603 114.588 128.795 120.547C128.795 120.547 129.938 120.411 130.885 119.795C130.885 119.795 123.452 98.2713 121.47 95.4048L114.609 95.9096Z",
    fill: "url(#paint93_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.539 102.549C119.483 102.549 119.428 102.52 119.395 102.47L117.923 100.142L116.881 99.9345C116.79 99.9161 116.731 99.8275 116.75 99.7373C116.768 99.647 116.858 99.5885 116.949 99.6069L118.062 99.8292C118.107 99.8376 118.146 99.866 118.171 99.9044L119.683 102.295C119.731 102.373 119.708 102.477 119.628 102.525C119.6 102.54 119.569 102.549 119.539 102.549Z",
    fill: "url(#paint94_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0487 71.4028C96.0487 71.4028 98.7774 71.9995 100.437 72.7567C100.766 72.9071 101.03 73.1712 101.18 73.4955C101.677 74.5719 103.163 77.2713 106.043 78.56C105.628 79.1049 104.961 80.2381 104.669 82.1436C102.938 80.8683 101.445 78.7405 100.728 75.2488C100.728 75.2488 100.182 75.543 99.5001 75.2154C99.1404 75.0416 98.725 74.7976 98.4126 74.6037C98.1019 74.4114 97.8706 74.1123 97.7811 73.7629C97.6629 73.3016 97.7322 72.8971 97.7322 72.4609L96.329 72.0313C96.329 72.033 95.9068 71.8759 96.0487 71.4028Z",
    fill: "url(#paint95_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.668 82.1451C104.958 80.2397 105.627 79.1064 106.042 78.5615C107.832 79.3622 110.159 79.6179 113.124 78.6017C113.398 78.5081 113.683 78.4529 113.972 78.4362C115.551 78.3443 120.75 78.1771 125.054 79.5845C125.959 79.8803 126.693 80.5439 127.072 81.4013C128.235 84.0456 130.12 90.0678 124.888 93.1082C124.486 92.1204 124.022 91.3264 123.625 90.7431C124.468 89.3357 124.718 87.4152 123.222 84.9131C122.131 87.8264 121.621 92.0786 121.513 93.9606C121.477 94.5807 121.587 95.1992 121.834 95.7708L121.861 95.8327C121.913 95.9547 121.841 96.0951 121.709 96.1252C118.764 96.7804 115.701 96.6015 114.786 96.528C114.622 96.5146 114.487 96.3993 114.45 96.2422C113.018 90.2684 113.014 86.1934 113.366 83.6177C112.022 83.9119 107.925 84.5453 104.668 82.1451Z",
    fill: "url(#paint96_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.356 83.825C113.349 83.825 113.341 83.825 113.334 83.8233C113.241 83.8116 113.177 83.728 113.189 83.6361C113.535 81.0504 114.231 79.9439 114.259 79.8971C114.31 79.8185 114.413 79.7968 114.492 79.8453C114.572 79.8954 114.595 79.9974 114.545 80.0759C114.538 80.0859 113.858 81.1791 113.523 83.6796C113.513 83.7648 113.44 83.825 113.356 83.825Z",
    fill: "url(#paint97_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.623 74.9546C120.623 74.9546 120.92 78.0735 121.184 78.9962C121.224 79.1366 121.162 79.2837 121.034 79.3555C120.588 79.6079 119.521 80.0174 118.06 79.3087C117.824 79.1934 117.682 78.9494 117.692 78.692L117.82 75.6783L120.623 74.9546Z",
    fill: "url(#paint98_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.761 70.9648C117.761 70.9648 116.808 73.131 116.744 74.2693C116.68 75.4059 116.432 76.1447 117.761 76.3737C119.089 76.6027 120.209 75.9474 120.815 74.8142C120.815 74.8142 121.766 73.0692 121.551 72.3538C121.339 71.6401 117.761 70.9648 117.761 70.9648Z",
    fill: "url(#paint99_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.359 74.0002L120.283 73.9667C120.186 73.925 120.146 73.8113 120.193 73.7194C120.381 73.3617 120.745 72.5393 120.274 72.3488C119.666 72.1014 117.258 71.615 116.738 70.7693C116.238 69.9569 116.681 68.9073 117.346 68.6081C117.39 68.588 117.442 68.6047 117.466 68.6465L117.522 68.7501C117.559 68.822 117.665 68.8103 117.689 68.7334C117.711 68.6599 117.811 68.6448 117.851 68.71C118.011 68.9624 118.442 69.3736 119.595 69.5842C121.235 69.8834 122.317 70.5403 122.344 71.6618C122.346 71.7337 122.422 71.7721 122.484 71.7354C122.606 71.6618 122.799 71.6284 123.059 71.844C123.509 72.2184 123.324 73.1912 122.338 73.9901C122.29 74.0286 122.29 74.1005 122.343 74.1339C122.522 74.2492 122.788 74.5233 122.098 74.8894C121.383 75.2671 120.85 75.2371 120.644 75.2036C120.593 75.1953 120.559 75.1468 120.571 75.0967L120.791 74.1105C120.803 74.0553 120.76 74.0018 120.703 74.0018H120.359V74.0002Z",
    fill: "url(#paint100_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.316 74.209C120.316 74.209 120.679 72.8251 121.308 73.2128C121.934 73.6006 120.982 74.7639 120.479 74.8158L120.316 74.209Z",
    fill: "url(#paint101_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.003 74.9764C99.9545 74.9764 99.9055 74.9546 99.8717 74.9145C99.4952 74.4549 98.8113 73.6793 98.5817 73.5506C98.3757 73.4353 98.2575 73.3049 98.222 73.1528C98.1916 73.0241 98.2237 72.8887 98.3183 72.75C98.3571 72.6948 98.4246 72.6664 98.4922 72.6798L99.6843 72.9155C99.713 72.9205 99.7383 72.9338 99.762 72.9522L100.395 73.4904C100.466 73.5506 100.475 73.6559 100.414 73.7261C100.353 73.7963 100.247 73.8047 100.176 73.7445L99.5762 73.2347L98.5547 73.0325C98.5496 73.0559 98.553 73.0692 98.5547 73.0759C98.5614 73.1077 98.5969 73.1729 98.7522 73.2598C99.1136 73.462 100.034 74.5769 100.139 74.7022C100.198 74.7741 100.186 74.8794 100.113 74.9379C100.078 74.9647 100.041 74.9764 100.003 74.9764Z",
    fill: "#F8A570"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.126 92.9259C122.126 92.9259 121.768 92.3342 120.932 92.3342C120.096 92.3342 119.141 93.872 119.141 93.872C119.141 93.872 120.454 94.4637 120.932 94.9367C121.41 95.4097 122.126 93.872 122.126 92.9259Z",
    fill: "url(#paint102_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.59 78.9009C121.781 78.6201 122.114 78.483 122.516 78.4897C122.977 78.4981 123.789 78.687 123.682 79.1934C123.367 80.6944 122.229 84.4418 118.548 85.9143L117.941 85.2441C118.526 84.5187 119.052 83.7565 119.583 82.9993C120.042 82.3441 120.386 81.6354 120.79 80.9551C120.988 80.6208 121.178 80.2882 121.288 79.9222C121.383 79.6063 121.388 79.2452 121.558 78.9527C121.57 78.9327 121.58 78.916 121.59 78.9009Z",
    fill: "url(#paint103_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.918 78.1504C116.861 77.7994 116.672 77.5688 116.4 77.4785C116.089 77.3732 115.496 77.3766 115.441 77.9499C115.277 79.6481 115.106 83.9755 117.212 86.476L117.786 85.9026C117.575 84.975 117.411 84.0223 117.244 83.0745C117.101 82.2539 117.045 81.4031 116.944 80.5674C116.895 80.1579 116.849 79.7517 116.868 79.3288C116.883 78.9644 116.971 78.575 116.928 78.2156C116.925 78.1922 116.922 78.1705 116.918 78.1504Z",
    fill: "url(#paint104_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.193 88.2676C119.378 88.2676 120.339 87.3165 120.339 86.1432C120.339 84.9699 119.378 84.0188 118.193 84.0188C117.008 84.0188 116.047 84.9699 116.047 86.1432C116.047 87.3165 117.008 88.2676 118.193 88.2676Z",
    fill: "url(#paint105_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M118.155 87.7412C119.026 87.7412 119.732 87.0422 119.732 86.18C119.732 85.3178 119.026 84.6189 118.155 84.6189C117.284 84.6189 116.578 85.3178 116.578 86.18C116.578 87.0422 117.284 87.7412 118.155 87.7412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.999 86.4091C119.998 86.4091 119.994 86.4091 119.993 86.4091C119.947 86.4057 119.912 86.364 119.915 86.3188C119.939 86.0414 119.917 85.784 119.847 85.555C119.834 85.5115 119.859 85.4647 119.905 85.4513C119.95 85.438 119.996 85.463 120.009 85.5082C120.084 85.7572 120.107 86.0347 120.082 86.3322C120.079 86.3757 120.043 86.4091 119.999 86.4091Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.759 85.2374C119.731 85.2374 119.702 85.2223 119.687 85.1956C119.276 84.5103 118.454 84.3632 118.446 84.3615C118.4 84.3532 118.368 84.3114 118.376 84.2646C118.385 84.2178 118.427 84.1894 118.474 84.196C118.511 84.2027 119.383 84.3548 119.834 85.1087C119.857 85.1488 119.844 85.1989 119.803 85.2223C119.788 85.234 119.773 85.2374 119.759 85.2374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2593 45.2095L42.1136 45.1025C41.8687 45.0942 41.6357 45.2062 41.4905 45.4L39.6179 47.9039C39.2515 48.3936 38.4747 48.2549 38.3059 47.6682L37.438 44.6746C37.3704 44.4423 37.1914 44.2568 36.9601 44.1799L33.9764 43.1904C33.3922 42.9965 33.2858 42.2243 33.7958 41.8816L36.4046 40.1383C36.6072 40.0029 36.7305 39.7773 36.7321 39.5349L36.7608 36.4193C36.7659 35.8092 37.4768 35.4699 37.9614 35.846L40.4419 37.7632C40.6344 37.9119 40.8894 37.9571 41.1224 37.8852L44.1246 36.9492C44.7122 36.7653 45.2576 37.3303 45.0466 37.9036L43.971 40.832C43.8865 41.0593 43.922 41.3133 44.0638 41.5106L45.8908 44.0478C46.2488 44.5426 45.8756 45.2296 45.2593 45.2095Z",
    fill: "url(#paint106_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6236 43.7319C37.4936 43.6316 37.3484 43.5547 37.193 43.5029L35.2444 42.856C35.0401 42.7875 34.8949 42.6137 34.8645 42.4031C34.8358 42.1908 34.9287 41.9852 35.1077 41.8665L36.8114 40.7283C37.2099 40.4608 37.4514 40.0179 37.4564 39.5415L37.475 37.5074C37.4767 37.2934 37.5983 37.1029 37.7942 37.011C37.9883 36.919 38.2146 36.9424 38.3851 37.0745L39.2125 37.7146L39.1146 37.84L38.2872 37.1998C38.1639 37.1046 38.0052 37.0878 37.8634 37.1547C37.7215 37.2216 37.6371 37.3553 37.6354 37.5107L37.6169 39.5449C37.6118 40.0731 37.345 40.5661 36.9026 40.862L35.1988 42.0002C35.0688 42.0872 35.003 42.2309 35.0249 42.3847C35.0469 42.5385 35.1482 42.6605 35.2968 42.7089L37.2454 43.3558C37.4193 43.4126 37.5797 43.4979 37.7232 43.6082L37.6236 43.7319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.442 46.7989C39.3475 46.8357 39.2411 46.8474 39.1364 46.8273C38.9236 46.7889 38.7548 46.6385 38.6957 46.4329L38.2617 44.9369L38.4154 44.8935L38.8493 46.3894C38.8932 46.5382 39.0114 46.6451 39.1651 46.6719C39.3204 46.7003 39.4673 46.6418 39.5619 46.5164L40.7844 44.8818C41.0985 44.4622 41.6169 44.2149 42.1454 44.2316L44.2004 44.3018C44.3574 44.3068 44.4958 44.2282 44.5701 44.0912C44.6444 43.9541 44.6343 43.797 44.5431 43.67L43.3493 42.0135C43.0386 41.5823 42.9626 41.0291 43.145 40.5326L43.8474 38.6205C43.9015 38.4751 43.8677 38.3196 43.7596 38.2077C43.6516 38.0957 43.4962 38.0555 43.3476 38.1023L41.3872 38.7141C41.1846 38.7776 40.9735 38.801 40.7625 38.7826L40.776 38.6255C40.9668 38.6422 41.1559 38.6205 41.3399 38.5637L43.3004 37.9519C43.5064 37.8884 43.7276 37.9436 43.8762 38.0973C44.0247 38.2511 44.072 38.4734 43.9994 38.674L43.297 40.5861C43.1332 41.0341 43.2007 41.5338 43.481 41.9216L44.6748 43.578C44.7998 43.7519 44.815 43.9775 44.712 44.1664C44.609 44.3553 44.4114 44.4672 44.197 44.4606L42.1437 44.3904C41.6675 44.3736 41.1998 44.5976 40.9178 44.9754L39.6953 46.61C39.6244 46.697 39.5383 46.7605 39.442 46.7989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2042 37.711L39.1055 37.8362L39.5966 38.2157L39.6953 38.0906L39.2042 37.711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1431 59.4636L92.845 59.385C92.666 59.3783 92.4955 59.4602 92.3891 59.6023L91.0197 61.4325C90.7512 61.7902 90.1855 61.6899 90.0606 61.2604L89.4257 59.0724C89.3767 58.902 89.245 58.7666 89.0761 58.7114L86.8945 57.9877C86.4673 57.8456 86.3897 57.2807 86.7628 57.0316L88.6692 55.758C88.8178 55.6593 88.9073 55.4939 88.909 55.3167L88.9292 53.0402C88.9326 52.5939 89.4527 52.3465 89.8073 52.6206L91.6208 54.0213C91.7609 54.13 91.9484 54.1634 92.1189 54.1099L94.3123 53.4263C94.7412 53.2926 95.1397 53.7037 94.9861 54.1233L94.2009 56.2627C94.1401 56.4299 94.1654 56.6154 94.2684 56.7592L95.6041 58.6128C95.8658 58.9772 95.5939 59.4786 95.1431 59.4636Z",
    fill: "url(#paint107_linear_10072_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5592 58.3837C89.4647 58.3102 89.3583 58.255 89.2434 58.2166L87.82 57.7435C87.6697 57.6934 87.5633 57.5664 87.5431 57.4126C87.5211 57.2571 87.5904 57.1067 87.7204 57.0198L88.9648 56.1874C89.257 55.9919 89.4326 55.6676 89.4359 55.3199L89.4495 53.8323C89.4511 53.6769 89.5406 53.5365 89.6825 53.4696C89.8243 53.4011 89.9898 53.4195 90.1147 53.5148L90.7192 53.9828L90.6466 54.0747L90.0421 53.6067C89.951 53.5365 89.8361 53.5248 89.7331 53.5733C89.6301 53.6234 89.5677 53.7203 89.566 53.834L89.5525 55.3216C89.5491 55.7077 89.3532 56.0671 89.0307 56.2844L87.7862 57.1167C87.6917 57.1803 87.6444 57.2856 87.6596 57.3975C87.6748 57.5095 87.7491 57.5981 87.8588 57.6349L89.2823 58.1079C89.4089 58.1497 89.5271 58.2115 89.6318 58.2934L89.5592 58.3837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8902 60.6253C90.821 60.652 90.7433 60.6604 90.6673 60.647C90.512 60.6186 90.3887 60.5083 90.3448 60.3579L90.0273 59.2647L90.1405 59.233L90.4579 60.3261C90.49 60.4347 90.5761 60.5133 90.6893 60.5334C90.8024 60.5534 90.9105 60.5116 90.978 60.4197L91.8712 59.2246C92.1009 58.9171 92.4791 58.7366 92.8658 58.7499L94.3669 58.8017C94.4817 58.8051 94.5831 58.7483 94.6371 58.648C94.6911 58.5477 94.6844 58.4323 94.6168 58.3404L93.7455 57.1303C93.5193 56.8161 93.4635 56.4116 93.5969 56.0489L94.1103 54.6515C94.1491 54.5445 94.1255 54.4326 94.0461 54.3507C93.9667 54.2688 93.8536 54.2403 93.7438 54.2738L92.3103 54.7201C92.1617 54.7669 92.008 54.7836 91.8544 54.7702L91.8645 54.6549C92.0046 54.6666 92.1431 54.6515 92.2765 54.6097L93.7101 54.1635C93.8604 54.1167 94.0225 54.1568 94.1305 54.2704C94.2403 54.3841 94.2741 54.5445 94.22 54.6916L93.7067 56.089C93.5868 56.4166 93.6358 56.781 93.8401 57.0651L94.7114 58.2752C94.8026 58.4023 94.8127 58.5677 94.7384 58.7048C94.6641 58.8419 94.5189 58.9238 94.3619 58.9187L92.8607 58.8669C92.5129 58.8552 92.1718 59.0174 91.9641 59.2948L91.0709 60.4899C91.0236 60.5501 90.9611 60.5969 90.8902 60.6253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7241 53.9828L90.6523 54.0737L91.0104 54.3505L91.0821 54.2596L90.7241 53.9828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M128.825 50.6517C128.346 50.0717 127.63 49.8327 126.927 50.0065C126.162 50.1954 125.73 50.9191 125.017 51.2083C123.775 51.7131 122.057 50.7152 121.115 52.0173C119.962 53.6085 119.07 52.4151 119.07 53.4948C119.07 54.5746 127.042 53.779 130.975 53.8358C131.544 53.8442 134.011 53.8024 132.949 52.6357C132.619 52.273 132.148 52.2128 131.709 52.1276C131.137 52.0173 129.777 51.9554 129.364 51.5158C129.141 51.2785 129.055 50.9375 128.854 50.6851C128.842 50.6734 128.834 50.6634 128.825 50.6517Z",
    fill: "url(#paint108_linear_10072_7190)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M26.1018 43.4361C25.0887 42.2126 23.5774 41.7078 22.0983 42.0739C20.484 42.4734 19.5722 43.9994 18.0711 44.6111C15.4504 45.6759 11.8268 43.5715 9.83769 46.3177C7.40448 49.6757 5.52344 47.1568 5.52344 49.4366C5.52344 51.7165 22.3397 50.0367 30.6373 50.157C31.8361 50.1737 37.0403 50.0885 34.7995 47.6248C34.1039 46.8593 33.111 46.7322 32.1857 46.5534C30.9783 46.3194 28.1095 46.1923 27.2365 45.263C26.7654 44.7633 26.5847 44.0445 26.1609 43.5097C26.139 43.4812 26.1204 43.4578 26.1018 43.4361Z",
    fill: "url(#paint109_linear_10072_7190)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 136,
    height: 136,
    rx: 68,
    stroke: "white",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10072_7190",
    x1: -9.35987,
    y1: 87.3981,
    x2: 148.591,
    y2: 87.3981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B37CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F895E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10072_7190",
    x1: 137.327,
    y1: 88.4833,
    x2: -5.31598,
    y2: 88.4833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B37CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F895E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10072_7190",
    x1: 80.9386,
    y1: 123.519,
    x2: 154.418,
    y2: 123.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A737D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF497A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10072_7190",
    x1: 28.3434,
    y1: 90.8396,
    x2: 38.9147,
    y2: 118.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A737D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF497A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10072_7190",
    x1: 68.7872,
    y1: 162.976,
    x2: 77.3896,
    y2: 81.0861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10072_7190",
    x1: 72.8831,
    y1: 121.019,
    x2: 72.6349,
    y2: 138.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10072_7190",
    x1: 19.859,
    y1: 117.309,
    x2: 28.495,
    y2: 140.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_10072_7190",
    x1: 24.2542,
    y1: 128.708,
    x2: 24.006,
    y2: 145.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_10072_7190",
    x1: 97.0697,
    y1: 132.117,
    x2: 145.531,
    y2: 132.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_10072_7190",
    x1: 121.176,
    y1: 133.722,
    x2: 120.928,
    y2: 150.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_10072_7190",
    x1: 68.4729,
    y1: 110.027,
    x2: 64.4107,
    y2: 110.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_10072_7190",
    x1: 58.2363,
    y1: 105.131,
    x2: 73.0609,
    y2: 116.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_10072_7190",
    x1: 67.139,
    y1: 105.309,
    x2: 66.3442,
    y2: 112.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_10072_7190",
    x1: 80.9066,
    y1: 108.578,
    x2: 66.5708,
    y2: 119.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_10072_7190",
    x1: 74.4445,
    y1: 110.084,
    x2: 80.1614,
    y2: 110.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_10072_7190",
    x1: 75.6805,
    y1: 106.205,
    x2: 74.937,
    y2: 112.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_10072_7190",
    x1: 70.9984,
    y1: 105.995,
    x2: 71.8901,
    y2: 77.7687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_10072_7190",
    x1: 70.0718,
    y1: 61.5217,
    x2: 69.2094,
    y2: 95.3065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB236D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C246D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_10072_7190",
    x1: 67.7187,
    y1: 60.8952,
    x2: 71.3554,
    y2: 60.8952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_10072_7190",
    x1: 372.689,
    y1: -217.05,
    x2: 377.474,
    y2: -221.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_10072_7190",
    x1: 66.9225,
    y1: 56.8773,
    x2: 72.6414,
    y2: 53.6921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_10072_7190",
    x1: 372.05,
    y1: -217.746,
    x2: 376.836,
    y2: -222.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_10072_7190",
    x1: 61.1337,
    y1: 61.2935,
    x2: 60.2713,
    y2: 95.0784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB236D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C246D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_10072_7190",
    x1: 60.0017,
    y1: 50.2018,
    x2: 57.986,
    y2: 56.8927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_10072_7190",
    x1: 78.3382,
    y1: 61.8743,
    x2: 79.2006,
    y2: 95.6591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB236D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C246D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_10072_7190",
    x1: 79.4715,
    y1: 50.7827,
    x2: 81.4873,
    y2: 57.4736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_10072_7190",
    x1: 55.9878,
    y1: 55.7817,
    x2: 76.802,
    y2: 37.6716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_10072_7190",
    x1: 51.3189,
    y1: 50.4206,
    x2: 72.1331,
    y2: 32.3104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_10072_7190",
    x1: 57.657,
    y1: 58.928,
    x2: 54.8471,
    y2: 68.4342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_10072_7190",
    x1: 62.9186,
    y1: 56.073,
    x2: 47.6647,
    y2: 66.6207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_10072_7190",
    x1: 76.6321,
    y1: 25.4772,
    x2: 31.6738,
    y2: 63.5343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_10072_7190",
    x1: 71.9393,
    y1: 46.9943,
    x2: 51.0886,
    y2: 63.5921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_10072_7190",
    x1: 50.1219,
    y1: 41.9558,
    x2: 61.4503,
    y2: 65.9496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_10072_7190",
    x1: 57.7863,
    y1: 55.5434,
    x2: 56.0962,
    y2: 55.8917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_10072_7190",
    x1: 65.7492,
    y1: 66.3574,
    x2: 69.5395,
    y2: 66.3574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18459F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2874B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_10072_7190",
    x1: 73.7593,
    y1: 66.3574,
    x2: 69.9689,
    y2: 66.3574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18459F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2874B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_10072_7190",
    x1: 70.0143,
    y1: 67.7577,
    x2: 69.8071,
    y2: 75.8739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_10072_7190",
    x1: 37.0321,
    y1: 80.8891,
    x2: 26.6203,
    y2: 84.3301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4421B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C0E16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_10072_7190",
    x1: 25.8739,
    y1: 78.5254,
    x2: 29.1458,
    y2: 78.5254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A737D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF497A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_10072_7190",
    x1: 29.7264,
    y1: 114.87,
    x2: 10.7775,
    y2: 135.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_10072_7190",
    x1: 23.5075,
    y1: 116.402,
    x2: 25.2094,
    y2: 116.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4421B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C0E16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_10072_7190",
    x1: 20.4256,
    y1: 114.904,
    x2: 24.1126,
    y2: 93.2658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D55D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#1C2873"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_10072_7190",
    x1: 25.427,
    y1: 110.959,
    x2: 6.47823,
    y2: 131.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_10072_7190",
    x1: 17.3756,
    y1: 116.316,
    x2: 18.8451,
    y2: 116.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4421B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C0E16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_10072_7190",
    x1: 16.1713,
    y1: 114.18,
    x2: 19.8582,
    y2: 92.5411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D55D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.098,
    stopColor: "#8251C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#1C2873"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_10072_7190",
    x1: 13.5042,
    y1: 88.1842,
    x2: 35.8833,
    y2: 71.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A737D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF497A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_10072_7190",
    x1: 9.97377,
    y1: 83.2965,
    x2: 36.5667,
    y2: 63.9628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A737D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF497A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_10072_7190",
    x1: 19.9325,
    y1: 72.9988,
    x2: 24.2828,
    y2: 72.9988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4421B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C0E16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_10072_7190",
    x1: 25.3196,
    y1: 70.2593,
    x2: 20.563,
    y2: 67.3284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4421B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C0E16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_10072_7190",
    x1: 18.0022,
    y1: 64.3274,
    x2: 24.1331,
    y2: 69.2192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_10072_7190",
    x1: 24.0622,
    y1: 71.3361,
    x2: 19.7825,
    y2: 68.6991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4421B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C0E16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_10072_7190",
    x1: 17.573,
    y1: 78.727,
    x2: 22.34,
    y2: 78.0371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18459F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2874B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_10072_7190",
    x1: 25.8418,
    y1: 77.8711,
    x2: 22.4709,
    y2: 78.3325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18459F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2874B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_10072_7190",
    x1: 22.6402,
    y1: 79.821,
    x2: 22.4542,
    y2: 87.1074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_10072_7190",
    x1: 23.9933,
    y1: 83.0226,
    x2: 13.1133,
    y2: 86.6184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4421B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C0E16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_10072_7190",
    x1: 23.3918,
    y1: 81.7893,
    x2: 12.98,
    y2: 85.2303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4421B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C0E16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_10072_7190",
    x1: 40.3561,
    y1: 82.5087,
    x2: 34.1736,
    y2: 84.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4421B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C0E16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_10072_7190",
    x1: 83.9292,
    y1: 43.4906,
    x2: 123.184,
    y2: 43.4906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_10072_7190",
    x1: 75.638,
    y1: 43.3111,
    x2: 94.5988,
    y2: 43.3111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_10072_7190",
    x1: 85.9502,
    y1: 40.7759,
    x2: 76.3676,
    y2: 53.8917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_10072_7190",
    x1: 87.3148,
    y1: 41.7742,
    x2: 77.7322,
    y2: 54.8899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_10072_7190",
    x1: 97.786,
    y1: 43.3968,
    x2: 94.2266,
    y2: 49.8115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_10072_7190",
    x1: 102.415,
    y1: 43.4614,
    x2: 98.8556,
    y2: 49.8761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_10072_7190",
    x1: 107.087,
    y1: 43.5267,
    x2: 103.527,
    y2: 49.9414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_10072_7190",
    x1: 111.841,
    y1: 43.5931,
    x2: 108.282,
    y2: 50.0078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_10072_7190",
    x1: 116.791,
    y1: 43.5931,
    x2: 113.232,
    y2: 50.0078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_10072_7190",
    x1: 105.878,
    y1: 63.499,
    x2: 138.71,
    y2: 63.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_10072_7190",
    x1: 98.9423,
    y1: 63.3052,
    x2: 114.801,
    y2: 63.3052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_10072_7190",
    x1: 107.565,
    y1: 61.189,
    x2: 99.55,
    y2: 72.1588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_10072_7190",
    x1: 108.708,
    y1: 62.0241,
    x2: 100.693,
    y2: 72.9939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_10072_7190",
    x1: 117.468,
    y1: 63.381,
    x2: 114.491,
    y2: 68.7462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_10072_7190",
    x1: 121.34,
    y1: 63.4351,
    x2: 118.363,
    y2: 68.8003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_10072_7190",
    x1: 125.245,
    y1: 63.4897,
    x2: 122.268,
    y2: 68.8549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_10072_7190",
    x1: 129.223,
    y1: 63.545,
    x2: 126.246,
    y2: 68.9102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_10072_7190",
    x1: 131.089,
    y1: 64.8516,
    x2: 134.033,
    y2: 64.8516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_10072_7190",
    x1: 9.29165,
    y1: 59.6545,
    x2: 42.1236,
    y2: 59.6545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_10072_7190",
    x1: 2.35241,
    y1: 59.4607,
    x2: 18.2109,
    y2: 59.4607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_10072_7190",
    x1: 10.975,
    y1: 57.3445,
    x2: 2.96021,
    y2: 68.3143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_10072_7190",
    x1: 12.1184,
    y1: 58.1796,
    x2: 4.10363,
    y2: 69.1494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_10072_7190",
    x1: 20.878,
    y1: 59.5363,
    x2: 17.901,
    y2: 64.9015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_10072_7190",
    x1: 24.7501,
    y1: 59.5904,
    x2: 21.7731,
    y2: 64.9555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_10072_7190",
    x1: 28.6587,
    y1: 59.645,
    x2: 25.6817,
    y2: 65.0102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_10072_7190",
    x1: 32.6367,
    y1: 59.7006,
    x2: 29.6596,
    y2: 65.0657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_10072_7190",
    x1: 34.503,
    y1: 61.0071,
    x2: 37.4473,
    y2: 61.0071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_10072_7190",
    x1: -16.671,
    y1: 133.677,
    x2: 32.8291,
    y2: 133.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB236D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C246D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_10072_7190",
    x1: 127.731,
    y1: 136.363,
    x2: 152.711,
    y2: 136.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB236D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C246D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_10072_7190",
    x1: 115.038,
    y1: 85.5015,
    x2: 118.797,
    y2: 91.1984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_10072_7190",
    x1: 121.244,
    y1: 124.654,
    x2: 114.698,
    y2: 124.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_10072_7190",
    x1: 114.723,
    y1: 113.814,
    x2: 116.186,
    y2: 118.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_10072_7190",
    x1: 120.64,
    y1: 121.611,
    x2: 118.797,
    y2: 121.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_10072_7190",
    x1: 132.931,
    y1: 125.745,
    x2: 130.423,
    y2: 125.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_10072_7190",
    x1: 126.577,
    y1: 110.035,
    x2: 128.04,
    y2: 114.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_10072_7190",
    x1: 130.998,
    y1: 120.659,
    x2: 128.795,
    y2: 120.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_10072_7190",
    x1: 113.174,
    y1: 97.1202,
    x2: 131.71,
    y2: 127.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_10072_7190",
    x1: 119.108,
    y1: 102.786,
    x2: 117.374,
    y2: 99.3504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_10072_7190",
    x1: 100.688,
    y1: 74.7123,
    x2: 109.304,
    y2: 86.0365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_10072_7190",
    x1: 111.041,
    y1: 77.345,
    x2: 139.833,
    y2: 111.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A737D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF497A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_10072_7190",
    x1: 113.188,
    y1: 81.8227,
    x2: 114.571,
    y2: 81.8227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A737D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF497A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_10072_7190",
    x1: 120.14,
    y1: 81.9765,
    x2: 119.203,
    y2: 77.0109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_10072_7190",
    x1: 117.56,
    y1: 72.8727,
    x2: 122.967,
    y2: 77.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_10072_7190",
    x1: 121.393,
    y1: 69.6056,
    x2: 116.384,
    y2: 76.1214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_10072_7190",
    x1: 118.234,
    y1: 71.9984,
    x2: 123.641,
    y2: 76.1777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_10072_7190",
    x1: 119.583,
    y1: 91.8397,
    x2: 122.062,
    y2: 95.595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_10072_7190",
    x1: 123.195,
    y1: 82.5712,
    x2: 118.428,
    y2: 81.8813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18459F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2874B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_10072_7190",
    x1: 114.925,
    y1: 81.7154,
    x2: 118.295,
    y2: 82.1768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18459F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2874B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_10072_7190",
    x1: 118.128,
    y1: 83.6652,
    x2: 118.314,
    y2: 90.9517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_10072_7190",
    x1: 40.8368,
    y1: 34.8093,
    x2: 37.6077,
    y2: 61.0629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_10072_7190",
    x1: 91.9109,
    y1: 51.8631,
    x2: 89.551,
    y2: 71.0496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_10072_7190",
    x1: 119.069,
    y1: 52.0087,
    x2: 133.209,
    y2: 52.0087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A737D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF497A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_10072_7190",
    x1: 5.52026,
    y1: 46.2978,
    x2: 35.3515,
    y2: 46.2978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A737D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF497A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10072_7190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 138,
    height: 138,
    rx: 69,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewAllPlayers);
export default __webpack_public_path__ + "static/media/ViewAllPlayers.b195e72a7914b61a58cce2af213dc7d7.svg";
export { ForwardRef as ReactComponent };